import React, { useState, useRef, useContext, useEffect, useMemo, useCallback } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import MessageList from './messgeList';
import MessageInput from './messageInput';
import axios from 'axios';
// import { processUserInput , handleGeneralConversation } from '../utils/langchainProcessor';
import { sendProcessedDataToBackend, enrichPeopleData, testBackendConnection } from '../api/api';
import { analyzeFoundPeople } from './dataAnalysis';
import { useCombinedContext } from './context/userContext';
import '../styles/chatInterface.css';
import Sidebar from './sideBar';
import NavBar from './navBar';
import { processWithLangChain, sendReviewedDataToBackend, createNewChat, fetchChatHistory, sendMessageToChat, getRecentChats, processUserInput, handleGeneralConversation, processEmailRequest, createGenAIPrompt, scrapeLinkedInProfile, searchCompanies, WebScraper, scrapeCompanyEmployees, searchJobs, LinkedInCompanyScraper , getLinkedInProfile, salesNavigatorSearch, generateMessageIds, getCompanyInfo, getFundingAcquisition, getFundingAnnouncements, getPersonChanges} from '../api/api';
import ReviewPrompt from './reviewPrompt';
import PeopleTable from './peopleTable';
import { v4 as uuidv4 } from 'uuid';
import { addStepToParticularSequence, createNewSequence, getActionBlockDetails, getAutomatedSequenceList, getAutomatedSequenceListDetails, getContactsFromConactList, getOnepgrContactLists, getProfileAttributes, getSenderAppAccounts, getSequenceLevelActionBlocks , getContactListEmails, getAccountsData} from '../api/onepgrApi';
import moment from 'moment';
import { createAndScheduleContactAction, createSequenceHistoryApi, generateOpenAiResponse } from '../api/meetSessionApi';
import ReviewSequenceModal from './sharedComponents/reviewSequence/ReviewSequenceModal';
import { processContentRequest } from '../api/writeraiApi';
import { updateSessionDetails } from '../api/babuApi';

const ChatInterface = ({ onLogout }) => {
  const [isStarred, setIsStarred] = useState(false);
  const [messages, setMessages] = useState([]);
  const [showScrollButton, setShowScrollButton] = useState(false);
  const [isTyping, setIsTyping] = useState(false);
  const [reviewData, setReviewData] = useState(null);
  const [editingMessageId, setEditingMessageId] = useState(null);
  const messagesEndRef = useRef(null);
  const messageAreaRef = useRef(null);
  const [peopleData, setPeopleData] = useState(null);
  const [enrichmentMode, setEnrichmentMode] = useState(null);
  // const { user, setUser } = useContext(useCombinedContext);
  const { sessionId } = useParams();
  const navigate = useNavigate();
  const [activeSessionId, setActiveSessionId] = useState(null);
  const context = useCombinedContext();
  const { user, setUser } = context;
  const [showWelcomeMessage, setShowWelcomeMessage] = useState(true);
  const sessionType = "4"
  const location = useLocation();
  const [isEnriched, setIsEnriched] = useState(false);
  const [recentChats, setRecentChats] = useState([]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const sidebarRef = useRef(null);
  const sidebarTriggerRef = useRef(null);
  const [senderAppAccounts, setSenderAppAccounts] = useState([]);
  const [emailStep, setEmailStep] = useState([])
  const [sequenceMode, setSequenceMode] = useState(null);
  const [automatedSequenceList, setAutomatedSequenceList] = useState(null);
  const [showExamples, setShowExamples] = useState(true);
  const [promptUserInput, sePromptUserInput] = useState('');
  const [autoScroll, setAutoScroll] = useState(true);
  const [dropSequenceMode, setDropSequenceMode] = useState("");
  const [selectedSequenceList, setSelectedSequenceList] = useState(null);
  const [selectedContactList, setSelectedContactList] = useState(null);
  const [userDetails, setUserDetails] = useState(null);
  const [enrichedPeopleData, setEnrichedPeopleData] = useState(null);
  const [engageSequenceMode, setEngageSequenceMode] = useState(null);
  const currentContactList_idRef = useRef(null);
  const [toggleSequenceReview, setToggleSequenceReview] = useState(false);
  const [selectedDropTime, setSelectedDropTime] = useState(moment().add(1, 'minute').format('YYYY-MM-DDTHH:mm'));
  const scheduledCotactionsRef = useRef(null);
  const [isOpenedByFindPeopleCard, setIsOpenedByFindPeopleCard] = useState(false);
  const [isOpenedByLikesAndCommentsCard, setIsOpenedByLikesAndCommentsCard] = useState(false);
  const [isOpenedByEmployeesSearchCard, setIsOpenedByEmployeesSearchCard] = useState(false);
  const [isOpenedByLinkedInProfileCard, setIsOpenedByLinkedInProfileCard] = useState(false);
  const [isOpenedByCompanyProfileCard, setIsOpenedByCompanyProfileCard] = useState(false);
  const [favouriteChats, setFavouriteChats] = useState([]);
  // New function to check if user is near bottom
  const isNearBottom = useCallback(() => {
    if (!messageAreaRef.current) return true;

    const container = messageAreaRef.current;
    const threshold = 100; // pixels from bottom to trigger auto-scroll
    return container.scrollHeight - container.scrollTop - container.clientHeight < threshold;
  }, []);

  // Improved scroll to bottom function
  const scrollToBottom = useCallback((behavior = 'smooth') => {
    if (messageAreaRef.current) {
      let scrollHeight = messageAreaRef.current.scrollHeight;
      const scrollEle = document.getElementsByClassName('message-list-container')[0]
      scrollHeight = scrollEle.scrollHeight
      scrollEle.scrollTo({
        top: scrollHeight,
        behavior: behavior
      });
    }
  }, [messages]);

  console.log("userDetails--->", user)

  // Handle scroll events to show/hide scroll button and manage auto-scroll
  const handleScroll = useCallback(() => {
    if (!messageAreaRef.current) return;

    const isAtBottom = isNearBottom();
    setAutoScroll(isAtBottom);
    setShowScrollButton(!isAtBottom);
  }, [isNearBottom]);

  console.log("recentChats--->", recentChats)

  // Add scroll event listener
  useEffect(() => {
    const messageArea = messageAreaRef.current;
    if (messageArea) {
      messageArea.addEventListener('scroll', handleScroll);
      return () => messageArea.removeEventListener('scroll', handleScroll);
    }
  }, [handleScroll]);

  // Auto-scroll when messages change or typing status changes
  useEffect(() => {
    if (autoScroll) {
      scrollToBottom(messages.length === 1 ? 'auto' : 'smooth');
    }
  }, [messages, isTyping, autoScroll, scrollToBottom]);


  useEffect(() => {
    const initializeChat = async () => {
      // If we have a URL sessionId, that takes precedence
      if (sessionId) {
        setActiveSessionId(sessionId);
        localStorage.setItem('lastSessionId', sessionId);
        await loadChatHistory(sessionId);
      } else {
        // Only use lastSessionId from localStorage if we don't have a URL sessionId
        const lastSessionId = localStorage.getItem('lastSessionId');
        if (lastSessionId) {
          setActiveSessionId(lastSessionId);
          navigate(`/chat/${lastSessionId}`);
          await loadChatHistory(lastSessionId);
        }
      }
      
      const resp = await getSenderAppAccounts();
      if (resp.success == '0' && resp.response) {
        setSenderAppAccounts(resp.response.app_accounts_list);
      }
    };

    initializeChat();
  }, [sessionId, location.pathname]); // Remove recentChats from dependencies

  useEffect(() => {
    fetchRecentChats();
  }, [user]);

  const fetchRecentChats = async () => {
    try {
      const chats = await getRecentChats(user.userId, sessionType);
      console.log("chats--->", chats)
      setRecentChats(chats.accountSessions);
      setFavouriteChats(chats.favoriteSessions);
    } catch (error) {
      console.error('Error fetching recent chats:', error);
    }
  };



  const handleExamplePromptClick = (prompt) => {
    handleUserInput(prompt);
  };

  useEffect(() => {
    // Show welcome message on page refresh
    setShowWelcomeMessage(true);
    setShowExamples(true);
  }, []);

  const handleSidebarMouseLeave = (e) => {
    // Check if the mouse is moving towards the main content
    if (e.clientX > sidebarRef.current.getBoundingClientRect().right) {
      setIsSidebarOpen(false);
    }
  };

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!isSidebarOpen) {
        const triggerRect = sidebarTriggerRef.current.getBoundingClientRect();
        if (e.clientX <= triggerRect.right && e.clientY >= triggerRect.top && e.clientY <= triggerRect.bottom) {
          setIsSidebarOpen(true);
        }
      }
    };

    document.addEventListener('mousemove', handleMouseMove);
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
    };
  }, [isSidebarOpen]);

  useEffect(() => {
    const path = location.pathname;

    const routeStateMap = {
        '/action-point/find-prospect/': setIsOpenedByFindPeopleCard,
        '/action-point/likes-and-comments/': setIsOpenedByLikesAndCommentsCard,
        '/action-point/employees-search/': setIsOpenedByEmployeesSearchCard,
        '/action-point/view-prospects/': setIsOpenedByLinkedInProfileCard,
        '/action-point/company-profile/': setIsOpenedByCompanyProfileCard,
    };

    // Reset all states to false initially
    Object.values(routeStateMap).forEach(setState => setState(false));

    // Set the appropriate state to true based on the route
    for (const [route, setState] of Object.entries(routeStateMap)) {
        if (path.includes(route)) {
            setState(true);
            break; // Exit loop once the correct route is found
        }
    }

}, [location]);

  const handleViewProfile = (linkedinUrl) => {
    // Send a prompt to view the LinkedIn profile
    const prompt = `View LinkedIn profile: ${linkedinUrl}`;
    handleUserInput(prompt); // Trigger the prompt
  };



  const loadChatHistory = async (chatId) => {
    try {
      const history = await fetchChatHistory(chatId, user.userId);
      if (Array.isArray(history) && history.length > 0) {
        setMessages(history);
        console.log("history --->", history);
        // Find the chat in recentChats and set isStarred accordingly
        const currentChat = recentChats.find(chat => chat._id === chatId);
        if (currentChat) {
          setIsStarred(currentChat.is_favourite_chat || false);
        }
      } else {
        console.log('No chat history found or empty history returned');
        setMessages([]);
        setIsStarred(false);
      }
    } catch (error) {
      console.error('Error loading chat history:', error);
      setMessages([]);
      setIsStarred(false);
    }
  };

  const handleNewChat = async () => {
    try {
      const newSessionId = await createNewChat(user.userId, sessionType);
      setActiveSessionId(newSessionId);
      localStorage.setItem('lastSessionId', newSessionId);
      setMessages([]);
      setShowWelcomeMessage(true);
      navigate(`/chat/${newSessionId}`);

    } catch (error) {
      console.error('Error creating new chat:', error);
    }
  };


  const toggleSidebar = () => {

    setIsSidebarOpen(!isSidebarOpen);
};

  const handleLogout = () => {
    setUser(null);
    onLogout();
  };



  useEffect(() => {
    testBackendConnection()
      .then(response => console.log('Backend connection successful:', response))
      .catch(error => console.error('Backend connection failed:', error));
  }, []);

  
  const toggleStar = () => {
    setIsStarred(!isStarred);
  };

  useEffect(() => {
    handleStarChat();
  }, [isStarred]);

  




  const handleUserInput = async (input) => {
    // Handle sequence cancellation
    if (input === 'cancel_sequence') {
      // Reset all modes
      setEnrichmentMode(null);
      setSequenceMode(null);
      setDropSequenceMode(null);
      setEngageSequenceMode(null);
      
      const cancelMessage = {
        id: uuidv4(),
        type: 'ai',
        message: 'Sequence cancelled. You can now start a new conversation.',
        time: new Date().toISOString()
      };
      setMessages(prev => [...prev, cancelMessage]);
      return;
    }
  
    const trimmedInput = input.trim();
  
    let newUserMessage;
  
    if (trimmedInput) {
      setAutoScroll(true);
      sePromptUserInput(trimmedInput);
      newUserMessage = { id: uuidv4(), type: 'human', message: trimmedInput, time: new Date().toISOString() };
      setMessages(prev => [...prev, newUserMessage]);
      setIsTyping(true);
  
      try {
        let currentSessionId = activeSessionId;
        if (!currentSessionId) {
          currentSessionId = await createNewChat(user.userId, sessionType);
          setActiveSessionId(currentSessionId);
          localStorage.setItem('lastSessionId', currentSessionId);
          navigate(`/chat/${currentSessionId}`);
        }
  
        // Check if the input is a sequence-breaking command
        if (enrichmentMode || sequenceMode || dropSequenceMode || engageSequenceMode) {
          const isValidInput = checkValidInput(trimmedInput, enrichmentMode, sequenceMode, dropSequenceMode, engageSequenceMode);
          
          if (!isValidInput) {
            const confirmBreak = window.confirm(
              "Your input doesn't match the expected options. Would you like to break the current sequence and continue with a new prompt?"
            );
            
            if (confirmBreak) {
              // Reset all modes
              setEnrichmentMode(null);
              setSequenceMode(null);
              setDropSequenceMode(null);
              setEngageSequenceMode(null);
              
              const breakMessage = {
                id: uuidv4(),
                type: 'ai',
                message: 'Sequence broken. You can now start a new conversation.',
                time: new Date().toISOString()
              };
              setMessages(prev => [...prev, breakMessage]);
              return;
            } else {
              return; // Don't send the message if user wants to stay in sequence
            }
          }
        }
  
        if (enrichmentMode === 'yesno') {
          await handleEnrichmentResponse(trimmedInput, newUserMessage);
        } else if (enrichmentMode === 'type') {
          await handleEnrichmentResponse(trimmedInput, newUserMessage);
        } else if (sequenceMode === 'yesno') {
          await handleSequenceCreation(trimmedInput, newUserMessage);
        } else if (sequenceMode === 'type') {
          await handleSequenceCreation(trimmedInput, newUserMessage);
        } else if (dropSequenceMode === 'yesno') {
          await handleDropSequence(trimmedInput, newUserMessage);
        } else if (dropSequenceMode === 'type') {
          await handleDropSequence(trimmedInput, newUserMessage);
        } else if (engageSequenceMode === 'yesno') {
          await handleEngageSequenceForLatestContactsList(trimmedInput, newUserMessage);
        } else if (engageSequenceMode === 'createEmial/createSequence') {
          await handleEngageSequenceForLatestContactsList(trimmedInput, newUserMessage);
        } else {
          const processedData = await processUserInput(trimmedInput, currentSessionId);
          console.log("processedData--->", processedData);
          if (processedData.needsReview) {
            setReviewData(processedData);
          } else {
            await handleProcessedData(processedData, currentSessionId, trimmedInput, newUserMessage);
          }
        }
      } catch (error) {
        console.error('Error processing input:', error);
        const errorMessage = {
          id: uuidv4(),
          type: 'ai',
          message: 'Error processing your request.',
          time: new Date().toISOString()
        };
        setMessages(prev => [...prev, errorMessage]);
      } finally {
        setIsTyping(false);
      }
    }
  };

  const checkValidInput = (input, enrichmentMode, sequenceMode, dropSequenceMode, engageSequenceMode) => {
    const lowerInput = input.toLowerCase().trim();
  
    if (enrichmentMode === 'yesno' || sequenceMode === 'yesno' || dropSequenceMode === 'yesno') {
      return ['yes', 'no'].includes(lowerInput);
    }
  
    if (engageSequenceMode === 'yesno') {
      return ['create an email', 'use existing sequence', 'create email', 'existing sequence', 'c', 'e'].some(option => 
        lowerInput === option.toLowerCase()
      );
    }
  
    if (enrichmentMode === 'type') {
      return ['email', 'phone', 'both', 'e', 'p', 'b'].includes(lowerInput);
    }
  
    if (sequenceMode === 'type') {
      return ['new sequence', 'existing sequence', 'new', 'existing', 'n', 'e'].includes(lowerInput);
    }
  
    if (dropSequenceMode === 'type') {
      return ['drop', 'execute'].some(option => lowerInput.includes(option));
    }
  
    if (engageSequenceMode === 'type') {
      return ['standalone email', 'create sequence', 'standalone', 'sequence', 's', 'c'].some(option => 
        lowerInput === option.toLowerCase()
      );
    }
  
    return true;
  };

  const handleStarChat = async () => {
    const favourite_chat = isStarred ? true : false;
    const payload = {
      query:{_id:activeSessionId},
      updateDocumnet:{
        is_favourite_chat:favourite_chat
      }
    }
    try {
      const response = await updateSessionDetails(payload);
      console.log("response--->", response);
      if(response && response.status === '1') {
        fetchRecentChats();
      } else {
        console.error('Failed to update session details:', response?.error || 'Unknown error');
      }
    } catch (error) {
      console.error('Error in handleStarChat:', error);
    }
  };



  const handleSendMessage = async (input, sessionId) => {
    const trimmedInput = input.trim();
    if (trimmedInput) {
      const newUserMessage = { id: uuidv4(), type: 'human', message: trimmedInput, time: new Date().toISOString() };

      setMessages(prev => [...prev, newUserMessage]);

      setIsTyping(true);

      try {
        setAutoScroll(true);
        // Process the user input
        const processedData = await processUserInput(trimmedInput, sessionId);
        console.log("processedData--->", processedData)
        setActiveSessionId(processedData.sessionId);
        if (processedData.needsReview) {
          setReviewData(processedData);

          // Don't proceed further, wait for user review
        } else {
          // Only proceed if no review is needed
          await handleProcessedData(processedData, sessionId, trimmedInput);
        }
      } catch (error) {
        console.error('Error processing prompt:', error);
        const errorMessage = {
          id: Date.now(),
          type: 'ai',
          message: 'Error processing your request.',
          time: new Date().toISOString()
        };
        setMessages(prev => [...prev, errorMessage]);

      } finally {
        setIsTyping(false);
      }
    }
  };



  const handleProcessedData = async (processedData, sessionId, userInput) => {
    console.log(userInput, processedData);
    let aiResponse;

    // Check if processedData has intents array, if not create empty array
    const intents = processedData.intents || [];
    
    if (intents.length > 0 ? intents[0].type === 'View Contact List' : processedData.type === 'View Contact List') {
      try {
        const contactListData = await getOnepgrContactLists();
        const { userMessageId, botMessageId } = generateMessageIds();
      
        console.log('Contact List Data:', contactListData);
        if (contactListData && contactListData.response && contactListData.response.lists_listing) {
          const contactListMessage = {
            id: uuidv4(),
            type: 'ai',
            message: { contactListData: contactListData.response },
            time: new Date().toISOString(),
            bot_message_id: botMessageId,
          };
          setMessages(prev => [...prev, contactListMessage]);
          
          // Send to chat history
          await sendMessageToChat(
            sessionId,
            userInput,
            JSON.stringify(contactListMessage.message),
            user.userId,
            sessionType,
            '',
            '',
            userMessageId,
            botMessageId
          );
        } else {
          const { userMessageId, botMessageId } = generateMessageIds();
          const noDataMessage = {
            id: uuidv4(),
            type: 'ai',
            message: 'No contact lists found.',
            time: new Date().toISOString(),
            bot_message_id: botMessageId,
          };
          setMessages(prev => [...prev, noDataMessage]);
          
          await sendMessageToChat(
            sessionId,
            userInput,
            noDataMessage.message,
            user.userId,
            sessionType,
            '',
            '',
            userMessageId,
            botMessageId
          );
        }
      } catch (error) {     
        console.error('Error fetching contact lists:', error);
        const { userMessageId, botMessageId } = generateMessageIds();
        const errorMessage = {
          id: uuidv4(),
          type: 'ai',
          message: 'Error retrieving contact lists. Please try again.',
          time: new Date().toISOString(),
          bot_message_id: botMessageId,
        };
        setMessages(prev => [...prev, errorMessage]);
        
        await sendMessageToChat(
          sessionId,
          userInput,
          errorMessage.message,
          user.userId,
          sessionType,
          '',
          '',
          userMessageId,
          botMessageId
        );
      }
      return;
    } else if (intents.length > 0 ? intents[0].type === 'View Accounts' : processedData.type === 'View Accounts') {
      try {
        const accountsData = await getAccountsData();
        console.log('Accounts Data:', accountsData);
        const { userMessageId, botMessageId } = generateMessageIds();
        if (accountsData && accountsData.success === '0' && accountsData.response) {
          const accountsMessage = {
            id: uuidv4(),
            type: 'ai',
            message: { accountsData: accountsData.response },
            time: new Date().toISOString(),
            bot_message_id: botMessageId,
          };
          setMessages(prev => [...prev, accountsMessage]);
          
          // Send to chat history
          await sendMessageToChat(
            sessionId,
            userInput,
            JSON.stringify(accountsMessage.message),
            user.userId,
            sessionType,
            '',
            '',
            userMessageId,
            botMessageId
          );
        } else {
          const { userMessageId, botMessageId } = generateMessageIds();
          const noDataMessage = {
            id: uuidv4(),
            type: 'ai',
            message: 'No accounts found.',
            time: new Date().toISOString(),
            bot_message_id: botMessageId,
          };
          setMessages(prev => [...prev, noDataMessage]);
          
          await sendMessageToChat(
            sessionId,
            userInput,
            noDataMessage.message,
            user.userId,
            sessionType,
            '',
            '',
            userMessageId,
            botMessageId
          );
        }
      } catch (error) {
        console.error('Error fetching accounts:', error);
        const { userMessageId, botMessageId } = generateMessageIds();
        const errorMessage = {
          id: uuidv4(),
          type: 'ai',
          message: 'Error retrieving accounts. Please try again.',
          time: new Date().toISOString(),
          bot_message_id: botMessageId,
        };
        setMessages(prev => [...prev, errorMessage]);
        
        await sendMessageToChat(
          sessionId,
          userInput,
          errorMessage.message,
          user.userId,
          sessionType,
          '',
          '',
          userMessageId,
          botMessageId
        );
      }
      return;
    } else if (processedData.type === 'general' || processedData.isGeneralConversation) {
      // Handle general conversation response
      aiResponse = processedData.content;
    } else {
      const result = await sendProcessedDataToBackend(processedData);
      if (result.data && result.data.found_people) {
        await handleFindPeople(result.data, sessionId, userInput);
        return;
      } else {
        aiResponse = processedData.content || 'Processed the request, but no specific action was taken.';
      }
    }
  
    const newAiMessage = { 
      id: uuidv4(), 
      type: 'ai', 
      message: aiResponse, 
      time: new Date().toISOString() 
    };
    setMessages(prev => [...prev, newAiMessage]);
  
    fetchRecentChats();
  };

  const handleFindPeople = async (data, sessionId, userInput) => {
    try {
      const { userMessageId, botMessageId } = generateMessageIds();
      console.log("people data---->", data);

      if (!data) {
        throw new Error('No data received');
      }

      let newMessages = [];

      // Handle case where no companies were found
      if (data.message === 'No companies found for the given criteria') {
        const noDataMessage = {
          id: uuidv4(),
          type: 'ai',
          message: data.message,
          time: new Date().toISOString(),
          bot_message_id: botMessageId,
        };
        newMessages.push(noDataMessage);
        setPeopleData([]);

        await sendMessageToChat(sessionId, userInput, noDataMessage.message, user.userId, sessionType, '', '', userMessageId, botMessageId);
        setMessages(prev => [...prev, noDataMessage]);
        return;
      }

      const foundPeople = data.found_people?.people || data.found_people || [];
      const companies = data.companies || [];
      const extractedInfo = data.extracted_info || {};
      console.log("found people-->", foundPeople);

      if (Array.isArray(foundPeople) && foundPeople.length === 0) {
        let companyMessage = '';
        if (companies.length > 0) {
          const hasSource = companies.some(company => company.source);
          
          companyMessage = `I found ${companies.length} companies matching your criteria:\n\n`;
          companies.forEach((company, index) => {
            companyMessage += `${index + 1}. ${company.name}\n`;
            if (company.website_url) {
              companyMessage += `   Website: ${company.website_url}\n`;
            }
            if (company.linkedin_url) {
              companyMessage += `   LinkedIn: ${company.linkedin_url}\n`; 
            }
            if (company.source) {
              companyMessage += `   Source: ${company.source}\n`;
            }
            companyMessage += '\n';
          });

          companyMessage += `\nI searched thoroughly for ${extractedInfo.title || 'professionals'} `;
          companyMessage += `in ${extractedInfo.location || 'the specified location'} across these companies.\n\n`;
          companyMessage += `I checked multiple data sources including Apollo and PDL, but unfortunately `;
          companyMessage += `I couldn't find any matching profiles that meet your specific criteria at this time.\n\n`;
          companyMessage += `Would you like to:\n`;
          companyMessage += `1. Try searching with different criteria\n`;
          companyMessage += `2. Expand the search to a broader location\n`;
          companyMessage += `3. Modify the job title or requirements`;
        } else {
          companyMessage = `I apologize, but I couldn't find any matching companies or professionals based on your search criteria.\n\n`;
          companyMessage += `To get better results, you might want to:\n`;
          companyMessage += `1. Broaden your search parameters\n`;
          companyMessage += `2. Check if the location or job title can be made more general\n`;
          companyMessage += `3. Try alternative keywords or industry terms`;
        }

        const noDataMessage = {
          id: uuidv4(),
          type: 'ai',
          message: companyMessage
        };
        newMessages.push(noDataMessage);

        setPeopleData([]);
      } else if (typeof foundPeople === 'string') {
        const { userMessageId, botMessageId } = generateMessageIds();
        const stringResponseMessage = {
          id: uuidv4(),
          type: 'ai',
          message: foundPeople,
          time: new Date().toISOString(),
          bot_message_id: botMessageId,
        };
        newMessages.push(stringResponseMessage);
        setPeopleData([]);
        } else if (Array.isArray(foundPeople)) {
      
        setPeopleData(foundPeople);
        setIsEnriched(false);

        try {
          const generatedInsights = await analyzeFoundPeople(foundPeople);

          newMessages = [
            {
              id: uuidv4(),
              type: 'ai',
              message: { insights: generatedInsights }
            },
            {
              id: uuidv4(),
              type: 'ai',
              message: { peopleData: foundPeople }
            },
            {
              id: uuidv4(),
              type: 'ai',
              message: 'Select contact(s) to enrich'
            }
          ];
        } catch (analysisError) {
          console.error('Error analyzing people:', analysisError);
          throw new Error(`Failed to analyze people data: ${analysisError.message}`);
        }
      } else {
        throw new Error('Invalid data structure received');
      }

      // Send messages to chat and update state
      if (newMessages.length > 0) {
        if (newMessages.length === 1) {
          await sendMessageToChat(sessionId, userInput, newMessages[0].message, user.userId, sessionType);
        } else {
          await sendMessageToChat(sessionId, userInput, JSON.stringify(newMessages[0].message), user.userId, sessionType);
          await sendMessageToChat(sessionId, '', JSON.stringify(newMessages[1].message), user.userId, sessionType);
          await sendMessageToChat(sessionId, '', JSON.stringify(newMessages[2].message), user.userId, sessionType);
        }

        setMessages(prev => [...prev, ...newMessages]);
      }
    } catch (error) {
      console.error('Error handling found people:', error);
      const errorMessage = {
        id: uuidv4(),
        type: 'ai',
        message: `Error processing results: ${error.message}`
      };
      await sendMessageToChat(sessionId, userInput, errorMessage.message, user.userId, sessionType);
      setMessages(prev => [...prev, errorMessage]);
    }
  };

  const handleLinkedInScrapeData = async (data, sessionId, userMessage) => {
    console.log('LinkedIn scrape data:', data);
    try {
      const { linkedin_post_data } = data;
      if (!linkedin_post_data?.post_LikesComments) {
        throw new Error('Invalid LinkedIn post data structure');
      }

      // Parse comments and likes
      const Comments = linkedin_post_data.post_LikesComments.comments?.data || [];
      const Likes = linkedin_post_data.post_LikesComments.likes?.data || [];

      // Transform comments data (Unipile shape — fields already normalised by backend)
      const formattedComments = Comments.map(comment => ({
        profileLink: comment.profileLink || '',
        linkedin_id: comment.linkedin_id || '',
        name:        comment.name || '',
        headline:    comment.headline || '',
        comment:     comment.comment || '',
        timestamp:   comment.timestamp || '',
        postUrl:     comment.postUrl || '',
        type:        'comment',
      }));

      // Transform reactions data
      const formattedLikes = Likes.map(like => ({
        profileLink:  like.profileLink || '',
        linkedin_id:  like.linkedin_id || '',
        name:         like.name || '',
        headline:     like.headline || '',
        reactionType: like.reactionType || '',
        postUrl:      like.postUrl || '',
        type:         'reaction',
      }));

      // Combine likes and comments, removing duplicates based on profileLink
      const combinedData = [...formattedComments, ...formattedLikes];
      const uniqueData = Array.from(new Set(combinedData.map(item => item.profileLink)))
        .map(profileLink => combinedData.find(item => item.profileLink === profileLink))
        .filter(Boolean);

      // Extract post URL for insights (using the first comment's URL if available)
      const postUrl = formattedComments[0]?.postUrl || "Post URL not available";

      // Generate insights
      const insights = `
        Post URL: ${postUrl}
        Total interactions: ${uniqueData.length}
        Comments: ${Comments.length}
        Likes: ${Likes.length}
        ${getMostCommonReaction(formattedLikes)}
      `;

      let newMessages = [
        { id: uuidv4(), type: 'ai', message: { insights: insights }, time: new Date().toISOString(), bot_message_id: generateMessageIds().botMessageId },
        { id: uuidv4(), type: 'ai', message: { linkedInData: uniqueData }, time: new Date().toISOString(), bot_message_id: generateMessageIds().botMessageId },
        {
          id: uuidv4(),
          type: 'ai',
          message: `Select contact(s) to enrich`,
          time: new Date().toISOString(),
          bot_message_id: generateMessageIds().botMessageId
        }
      ];

      // Send messages to chat and update state
      for (let message of newMessages) {
        await sendMessageToChat(sessionId, userMessage, JSON.stringify(message.message), user.userId, sessionType, '', '', generateMessageIds().userMessageId, message.bot_message_id);
      }

      setMessages(prev => [...prev, ...newMessages]);
    } catch (error) {
      console.error('Error handling LinkedIn scrape data:', error);
      const { userMessageId, botMessageId } = generateMessageIds();
      const errorMessage = { 
        id: uuidv4(), 
        type: 'ai', 
        message: `Error fetching LinkedIn post engagement: ${error.message}`,
        time: new Date().toISOString(),
        bot_message_id: botMessageId
      };
      await sendMessageToChat(sessionId, null, errorMessage.message, user.userId, sessionType, '', '', userMessageId, botMessageId);
      setMessages(prev => [...prev, errorMessage]);
    }
  };

  const getMostCommonReaction = (data) => {
    if (!data || data.length === 0) {
      return "Most common reaction: No reactions available";
    }

    const reactionCounts = data.reduce((acc, item) => {
      if (item.reactionType) {
        acc[item.reactionType] = (acc[item.reactionType] || 0) + 1;
      }
      return acc;
    }, {});

    if (Object.keys(reactionCounts).length === 0) {
      return "Most common reaction: No reactions available";
    }

    const [mostCommonReaction, count] = Object.entries(reactionCounts)
      .sort((a, b) => b[1] - a[1])[0];

    return `Most common reaction: ${mostCommonReaction} (${count} times)`;
  };


  const getLinkedInCookie = async (userId) => {
    console.log("userId----->", userId)
    const url = 'https://onepgr.com/users/get_profile_attributes?onepgr_apicall=1&xhr_flag=1';
    const body = new FormData();
    body.append('id', userId);
    body.append('public_view', '1');

    try {
      const response = await axios.post(url, body);
      const parsedResponse = response.data;
      console.log("API Response:", parsedResponse);

      if (parsedResponse && parsedResponse.response) {
        const userDetails = JSON.parse(parsedResponse.response);
        if (userDetails.api_keys) {
          const apiKeys = JSON.parse(userDetails.api_keys);
          if (apiKeys.linkedIn && apiKeys.linkedIn.cookie) {
            console.log('LinkedIn Cookie:', apiKeys.linkedIn.cookie);
            return apiKeys.linkedIn.cookie;
          }
        }
      }
      throw new Error('LinkedIn cookie not found in the response');
    } catch (error) {
      console.error('Error fetching LinkedIn cookie:', error);
      throw error;
    }
  };

  const handleReviewAction = async (action, data) => {
    console.log('Handling review action:', action, data);
    if (action === 'process') {
      setIsTyping(true);
      try {
        let dataWithUserId = {
          ...data,
          userId: user.userId
        };

        if (data.intents && Array.isArray(data.intents)) {
          const linkedInIntent = data.intents.find(intent =>
             intent.type === 'Scrape Company Employees from LinkedIn' || intent.type === 'LinkedIn Messages Scraper' || intent.type === 'LinkedIn Event Attendees Scraper'
          );
          if (linkedInIntent) {
            const linkedinCookie = await getLinkedInCookie(user.userId || user.id);
            console.log('LinkedIn Cookie:', linkedinCookie);
            dataWithUserId = {
              ...dataWithUserId,
              sessionCookie: linkedinCookie,
            };
          }
        }
        const intent = data.intents[0];
        if (intent.type === 'create sequence') {
          await handleCreateSequenceAgent(intent, data.input);
        } else if (intent.type === 'sequence schedule') {
          await handleSequenceExecution(intent, data.input);
        } else if (intent.type === 'Video Creator') {
          const inputData = typeof data.input === 'string' ? data.input : JSON.stringify(data.input);
          console.log(inputData)
          await handleVideoCreator(intent, inputData)
        } else if (intent.type === 'IP Enrichment') {
          // const ipAddress = String(intent.extractedInfo.ipAddress)
          // console.log(ipAddress)
          await handleIpEnrichment(intent);
        } else if (intent.type === 'LinkedIn Messages Scraper') {
          const linkedinCookie = await getLinkedInCookie(user.userId || user.id);
          dataWithUserId = {
            ...dataWithUserId,
            sessionCookie: linkedinCookie,
          };

          // Call the LinkedIn Messages handler
          await handleLinkedInMessages(dataWithUserId, activeSessionId, data.input);
        } else if (intent.type === 'LinkedIn Jobs Scraper') {
          const { keywords, location } = intent.extractedInfo || {};
          console.log('Job search params:', { keywords, location });
      
          // Pass the control to the function and handle all within it
          await handleScrapedJobData({ keywords, location }, activeSessionId, data.input);
      } else if (intent.type === 'LinkedIn Job Details') {
        const { jobUrl } = intent.extractedInfo || {};
        console.log('Job URL:', jobUrl);
    
        if (!jobUrl) {
            // If no valid job URL is provided, return early or handle differently
            console.log('No valid LinkedIn job URL provided.');
            return; // Optionally, return early or handle silently, without sending an error message
        }
    
        // Pass control to the function and handle job details retrieval
        await handleJobDetails({ jobUrl }, activeSessionId, data.input);
    } else if (intent.type === 'LinkedIn Event Attendees Scraper') {
          const linkedinCookie = await getLinkedInCookie(user.userId || user.id);
          const eventUrl = intent.extractedInfo.eventUrl;
          
          await handleLinkedInEventAttendees({
            sessionCookie: linkedinCookie,
            eventUrl: eventUrl
          }, activeSessionId, data.input);
        }
        
        else {
          let result;
          switch (intent.type) {
            case 'create email':
              result = await processEmailRequest(
                intent.editedInfo.recipient || '',
                intent.editedInfo.topic || '',
                intent.editedInfo.emailType || '',
                activeSessionId,
                data.input
              );
              break;
            case 'create gen ai prompt':
              result = await createGenAIPrompt(
                intent.editedInfo.task || '',
                intent.editedInfo.aspect || '',
                activeSessionId,
                data.input
              );
              break;
            case 'Company Finder':
              // Extract company type and location from editedInfo
              const searchParams = {
                keywords: intent.editedInfo?.companyType || '',
                location: intent.editedInfo?.location || '',
                page: 1,
                perPage: 10,
                userId: user.userId
              };

              console.log('Searching companies with:', searchParams);
              result = await searchCompanies(searchParams);
              break;
            case 'LinkedIn profile scraper':
              result = await getLinkedInProfile(
                intent.editedInfo.profileUrl || '',
              );
              break;
            case 'Scrape LinkedIn Company Profile':
              result = await getCompanyInfo(
                intent.editedInfo.profileUrl || '',
               
              );
              break;
            case 'Scrape Company Employees from LinkedIn':
              result = await scrapeCompanyEmployees(
                intent.editedInfo.companyUrl || '',
                dataWithUserId.sessionCookie
              );
              break;
            case 'Web Scraper':
              result = await WebScraper(
                intent.editedInfo.data || '',
              );
              break;
            case 'Job Search':
              result = await searchJobs(
                intent.editedInfo.jobTitle || '',
                intent.editedInfo.location || '',
              );
              break;
              case 'Content Writer':
                result = await processContentRequest({
                  sessionId: activeSessionId,
                  input: data.input,
                  userId: user.userId
                });
                console.log("result from content writer", result)
                break;
            case 'Sales Navigator Search':
              // Extract all fields from editedInfo and pass them directly to the search
              const salesNavParams = intent.editedInfo || {};
              result = await salesNavigatorSearch(
                salesNavParams,
               
              );
              
              break;
            case 'company funding acquisition':
              result = await getFundingAcquisition(
                intent.extractedInfo.domain || ''
              );
              console.log('Funding Acquisition Response:', result);
              // Handle the response data
             
              break;
            case 'funding announcement':
              result = await getFundingAnnouncements(
                intent.extractedInfo.domain || ''
              );
              console.log('Funding Announcement Response:', result);
            
              break;
            case 'person job changes':
              result = await getPersonChanges(
                intent.extractedInfo.linkedinUrl || '',
                intent.extractedInfo.year || new Date().getFullYear()
              );
              console.log('Person Job Changes Response:', result);
              break;
            default:
              result = await sendReviewedDataToBackend(dataWithUserId);
          }

          console.log('Result from processing:', result);
          if (result.profile) {
            await handleLinkedInProfileScrapeData(result.profile, activeSessionId, data.input);
          } else if (result.content) {
            await handleContentWriterData(result,sessionId, data.input);
          } else if (result.data && result.data.salesNavigatorData) {
            await handleSalesNavigatorResults(result.data, activeSessionId, data.input);
          } else if (result.data && result.data.linkedin_post_data) {
            await handleLinkedInScrapeData(result.data, activeSessionId, data.input);
          } else if (result.employees) {
            await handleCompanyEmployeeData(result.employees, activeSessionId, data.input);
          } else if (result.Company_Profile) {
            await handleCompanyProfileData(result.Company_Profile, activeSessionId, data.input);
          }
          else if (result.jobs) {
            await handleJobSearchData(result.jobs, activeSessionId, data.input);
          } else if (result.data && result.data.found_people) {
            await handleFindPeople(result.data, activeSessionId);
          } else if (result.email_content) {
            console.log('result.email_content--->', result.email_content)
            await handleEmailProcessing(result.email_content, activeSessionId);
          } else if (result.gen_ai_content) {
            await handleGenAIPromptProcessing(result.gen_ai_content, activeSessionId);
          } else if (result.data && Array.isArray(result.data)) {  // Check for web scraper data
            await handleWebScraperData(result.data, activeSessionId, data.input);
          } else if (result.content) {
            const { userMessageId, botMessageId } = generateMessageIds();
            const aiMessage = {
              id: uuidv4(),
              type: 'ai',
              message: result.content,
              messageType: 'general',
              time: new Date().toISOString(),
              bot_message_id: botMessageId
            };
            setMessages(prev => [...prev, aiMessage]);
            await sendMessageToChat(activeSessionId, data.input, JSON.stringify(aiMessage), user.userId, sessionType, '', '', userMessageId, botMessageId);
          } else if (result.FundingAndAcquisitionData) {
            await handleFundingAcquisitionData(result.FundingAndAcquisitionData, activeSessionId, data.input);
          } else if (result.FundingannounmenetData) {
            await handleFundingAnnouncement(result.FundingannounmenetData, activeSessionId, data.input);
          } else if (result.PersonChangesData) {
            await handlePersonJobChanges(result.PersonChangesData, activeSessionId, data.input);
          }
          else {
            throw new Error('Unexpected response structure from backend');
          }
        }
      } catch (error) {
        console.error('Error processing reviewed data:', error);
        const { userMessageId, botMessageId } = generateMessageIds();
        const backendErrorMessage = error.response?.data?.error || error.message;
        const errorMessage = {
          id: Date.now(),
          type: 'ai',
          message: `Error processing your request after review: ${backendErrorMessage}`,
          time: new Date().toISOString(),
          bot_message_id: botMessageId
        };
        setMessages(prev => [...prev, errorMessage]);
      } finally {
        setIsTyping(false);
        setReviewData(null);
      }
    } else if (action === 'edit') {
      const lastUserMessage = messages[messages.length - 1];
      setEditingMessageId(lastUserMessage.id);
    } else if (action === 'cancel') {
      setReviewData(null);
    } else if (action === 'general') {
      setReviewData(null);
      await handleGeneralPrompt(data.input || data, true);
    }
  };



  const handleEmailProcessing = async (data, sessionId, userInput) => {
    console.log('data----->', data)
    try {
      const emailContent = data;
      setEmailStep([{
        subject: emailContent.subject,
        msg_body: emailContent.body,
        time_offset: '0',
        isgenEmail: false
      }])
      let newMessages = [];
      if (!emailContent) {
        const { userMessageId, botMessageId } = generateMessageIds();
        const noDataMessage = {
          id: uuidv4(),
          type: 'ai',
          message: 'No email content generated.',
          time: new Date().toISOString(),
          bot_message_id: botMessageId
        };
        newMessages.push(noDataMessage);
        await sendMessageToChat(sessionId, '', newMessages[0].message, user.userId, sessionType, '', '', userMessageId, botMessageId);
      } else {
        const { userMessageId, botMessageId } = generateMessageIds();
        const emailMessage = {
          id: uuidv4(),
          type: 'ai',
          message: { emailData: emailContent },
          time: new Date().toISOString(),
          bot_message_id: botMessageId
        };
        newMessages.push(emailMessage);
        // await sendMessageToChat(sessionId, promptUserInput,emailMessage.message, user.userId, sessionType);

        // Add a prompt for further action
        // newMessages.push({
        //   id: uuidv4(),
        //   type: 'ai',
        //   content: 'Would you like to edit this email or send it as is? (Edit/Send)'
        // });
        newMessages.push({
          id: uuidv4(),
          type: 'ai',
          message: 'Would you like to add this step to sequence?  (Yes/No)'
        });
        // await sendMessageToChat(sessionId, '', 'Would you like to add this step to sequence?  (Yes/No)', user.userId, sessionType);
        setSequenceMode('yesno');
      }


      // Send messages to chat and update state
      // for (let message of newMessages) {
      //   await sendMessageToChat(sessionId, userInput, JSON.stringify(message.message), user.userId, sessionType);
      // }




      setMessages(prev => [...prev, ...newMessages]);
    } catch (error) {
      console.error('Error handling email processing:', error);
      const { userMessageId, botMessageId } = generateMessageIds();
      const errorMessage = { id: uuidv4(), type: 'ai', message: `Error handling email processing: ${error.message}`,
        time: new Date().toISOString(),
        bot_message_id: botMessageId
      };
      await sendMessageToChat(sessionId, userInput, errorMessage.message, user.userId, sessionType, '', '', userMessageId, botMessageId);
      setMessages(prev => [...prev, errorMessage]);
    }
  };

  const handleGenAIPromptProcessing = async (data, sessionId, userInput) => {
    try {
      setEmailStep([{
        subject: data.subject,
        msg_body: data.body,
        time_offset: '0',
        isgenEmail: true
      }])
      const promptContent = data;
      let newMessages = [];

      if (!promptContent) {
        const { userMessageId, botMessageId } = generateMessageIds();
        const noDataMessage = {
          id: uuidv4(),
          type: 'ai',
          message: 'No gen AI prompt generated.',
          time: new Date().toISOString(),
          bot_message_id: botMessageId
        };
        newMessages.push(noDataMessage);
      } else {
        const { userMessageId, botMessageId } = generateMessageIds();
        const promptMessage = {
          id: uuidv4(),
          type: 'ai',
          message: { genAIPromptData: promptContent },
          time: new Date().toISOString(),
          bot_message_id: botMessageId
        };
        newMessages.push(promptMessage);

        // Add a prompt for further action
        // newMessages.push({
        //   id: uuidv4(),
        //   type: 'ai',
        //   content: 'Would you like to edit this gen AI prompt or use it as is? (Edit/Use)'
        // });
        newMessages.push({
          id: uuidv4(),
          type: 'ai',
          message: 'Would you like to add this step to sequence?  (Yes/No)'
        });
        setSequenceMode('yesno');
      }

      // Send messages to chat and update state
      for (let message of newMessages) {
        const { userMessageId, botMessageId } = generateMessageIds();
        await sendMessageToChat(sessionId, userInput, JSON.stringify(message.message), user.userId, sessionType, '', '', userMessageId, botMessageId);
      }

      setMessages(prev => [...prev, ...newMessages]);
    } catch (error) {
      console.error('Error handling gen AI prompt processing:', error);
      const { userMessageId, botMessageId } = generateMessageIds();
      const errorMessage = { id: uuidv4(), type: 'ai', message: `Error handling gen AI prompt processing: ${error.message}`,
        time: new Date().toISOString(),
        bot_message_id: botMessageId
      };
      // await sendMessageToChat(sessionId, userInput, errorMessage.content, user.userId, sessionType);
      setMessages(prev => [...prev, errorMessage]);
    }
  };

  const handleWebScraperData = async (data, sessionId, userInput) => {
    console.log('Web Scraper data:', data);


    try {
      let newMessages = [];

      if (!data || data.length === 0) {
        const { userMessageId, botMessageId } = generateMessageIds();
        const noDataMessage = {
          id: uuidv4(),
          type: 'ai',
          message: 'No results found from web scraping.',
          time: new Date().toISOString(),
          bot_message_id: botMessageId
        };
        newMessages.push(noDataMessage);
        await sendMessageToChat(sessionId, '', noDataMessage.message, user.userId, sessionType, '', '', userMessageId, botMessageId);
      } else {
        // Format the scraped results into a readable message
        const formattedResults = data.map((item, index) => {
          return `${index + 1}. ${item.title}\n` +
            `   Link: ${item.link}\n` +
            `   ${item.snippet}\n` +
            `   ${item.date ? `Date: ${item.date}\n` : ''}`;
        }).join('\n\n');

        const { userMessageId, botMessageId } = generateMessageIds();
        // Create message with formatted results
        const resultsWebMessage = {
          id: uuidv4(),
          type: 'ai',
          message: { webData: formattedResults },
          time: new Date().toISOString(),
          bot_message_id: botMessageId
        };
        setMessages(prev => [...prev, resultsWebMessage]);
        await sendMessageToChat(sessionId, userInput, JSON.stringify(resultsWebMessage.message), user.userId, sessionType, '', '', userMessageId, botMessageId);
      }


    } catch (error) {
      console.error('Error handling web scraper data:', error);
      const { userMessageId, botMessageId } = generateMessageIds();
      const errorMessage = {
        id: uuidv4(),
        type: 'ai',
        message: `Error processing web scraper results: ${error.message}`,
        time: new Date().toISOString(),
        bot_message_id: botMessageId
      };
      await sendMessageToChat(sessionId, userInput, errorMessage.message, user.userId, sessionType, '', '', userMessageId, botMessageId);
      setMessages(prev => [...prev, errorMessage]);
    }
  };

  const handleCompanyEmployeeData = async (data, sessionId, userInput) => {
    console.log('Company Employee data:', data, userInput);

    try {
      let newMessages = [];

      if (!data) {
        const { userMessageId, botMessageId } = generateMessageIds();
        const noDataMessage = {
          id: uuidv4(),
          type: 'ai',
          message: 'No employees found from the company search.',
          time: new Date().toISOString(),
          bot_message_id: botMessageId
        };
        newMessages.push(noDataMessage);
        await sendMessageToChat(sessionId, userInput, noDataMessage.message, user.userId, sessionType, '', '', userMessageId, botMessageId);
      } else {
        const { userMessageId, botMessageId } = generateMessageIds();
        const resultsEmployeeMessage = {
          id: uuidv4(),
          type: 'ai',
          message: { employeeData: data },
          time: new Date().toISOString(),
          bot_message_id: botMessageId
        };

        setMessages(prev => [...prev, resultsEmployeeMessage, newMessages]);

        // Send both messages to chat
        await sendMessageToChat(
          sessionId,
          userInput,
          JSON.stringify(resultsEmployeeMessage.message),
          user.userId,
          sessionType,
          '',
          '',
          userMessageId,
          botMessageId
        );

      }

    } catch (error) {
      console.error('Error handling company employee data:', error);
      const { userMessageId, botMessageId } = generateMessageIds();
      const errorMessage = {
        id: uuidv4(),
        type: 'ai',
        message: `Error processing company employee results: ${error.message}`,
        time: new Date().toISOString(),
        bot_message_id: botMessageId
      };
      await sendMessageToChat(sessionId, userInput, errorMessage.message, user.userId, sessionType, '', '', userMessageId, botMessageId);
      setMessages(prev => [...prev, errorMessage]);
    }
  };

  const handleJobSearchData = async (data, sessionId, userInput) => {
    console.log('Job search data:', data, userInput);
    try {
      let newMessages = [];

      if (!data) {
        const { userMessageId, botMessageId } = generateMessageIds();
        const noDataMessage = {
          id: uuidv4(),
          type: 'ai',
          message: 'No jobs found matching your search criteria.',
          time: new Date().toISOString(),
          bot_message_id: botMessageId
        };
        newMessages.push(noDataMessage);
        await sendMessageToChat(sessionId, userInput, noDataMessage.message, user.userId, sessionType, '', '', userMessageId, botMessageId);
      } else {
        const { userMessageId, botMessageId } = generateMessageIds();
        const jobsMessage = {
          id: uuidv4(),
          type: 'ai',
          message: {
            jobData: data
          },
          time: new Date().toISOString(),
          bot_message_id: botMessageId
        };

        setMessages(prev => [...prev, jobsMessage, newMessages]);

        // Send both messages to chat
        await sendMessageToChat(
          sessionId,
          userInput,
          JSON.stringify(jobsMessage.message),
          user.userId,
          sessionType,
          '',
          '',
          userMessageId,
          botMessageId
        );
      }

    } catch (error) {
      console.error('Error handling job search data:', error);
      const { userMessageId, botMessageId } = generateMessageIds();
      const errorMessage = {
        id: uuidv4(),
        type: 'ai',
        message: `Error processing job search results: ${error.message}`,
        time: new Date().toISOString(),
        bot_message_id: botMessageId
      };
      await sendMessageToChat(sessionId, userInput, errorMessage.message, user.userId, sessionType, '', '', userMessageId, botMessageId);
      setMessages(prev => [...prev, errorMessage]);
    }
  };



  // const handleLinkedInProfileScrapeData = async (data, sessionId, input) => {
  //   try {
  //     console.log('Handling LinkedIn profile scrape data:', data);

  //     // Extract relevant data from the parsed JSON
  //     const {
  //       general,
  //       jobs,
  //       schools,
  //       skills,
  //       allSkills
  //     } = data;

  //     // Get current job (first item in jobs array since it's ordered by date)
  //     const currentPosition = jobs.find(job => job.isCurrent);

  //     // Format education information
  //     const formattedEducation = schools.map(school =>
  //       `${school.schoolName}: ${school.degree}`
  //     ).join('\n');

  //     // Format skills with endorsement counts
  //     const formattedSkills = skills
  //       .sort((a, b) => b.endorsements - a.endorsements)
  //       .map(skill => `${skill.name} (${skill.endorsements} endorsements)`)
  //       .join('\n');

  //     // Create a formatted message with the scraped profile data
  //     const profilePostData = data;

  //     // Create an AI message with the formatted profile data
  //     const aiMessage = {
  //       id: uuidv4(),
  //       type: 'ai',
  //       message: { linkedinProfileData: data },
  //       time: new Date().toISOString()
  //     };

  //     // Update the messages state with the new AI message
  //     setMessages(prev => [...prev, aiMessage]);

  //     // Send the AI message to the chat
  //     await sendMessageToChat(sessionId, input, JSON.stringify(aiMessage.message), user.userId, sessionType);

  //   } catch (error) {
  //     console.error('Error handling LinkedIn profile scrape data:', error);

  //     // Create an error message
  //     const errorMessage = {
  //       id: uuidv4(),
  //       type: 'ai',
  //       message: `Error processing LinkedIn profile data: ${error.message}`,
  //       time: new Date().toISOString()
  //     };

  //     // Update the messages state with the error message
  //     setMessages(prev => [...prev, errorMessage]);
  //   }
  // };

  const handleContentWriterData = async (data, sessionId, userInput) => {
    console.log('Content Writer data:', data);
  
    try {
      let newMessages = [];
  
      if (!data) {
        const { userMessageId, botMessageId } = generateMessageIds();
        const noDataMessage = {
          id: uuidv4(),
          type: 'ai',
          message: 'No content was generated. Please try again.',
          time: new Date().toISOString(),
          bot_message_id: botMessageId
        };
        newMessages.push(noDataMessage);
        await sendMessageToChat(sessionId, '', noDataMessage.message, user.userId, sessionType, '', '', userMessageId, botMessageId);
      } else {
        const { userMessageId, botMessageId } = generateMessageIds();

        const contentMessage = {
          id: uuidv4(),
          type: 'ai',
          message: {contentData: data}, // Send the string directly, not an object
          time: new Date().toISOString(),
          bot_message_id: botMessageId
        };
  
        // Add the message to the chat
        setMessages((prev) => [...prev, contentMessage]);
        await sendMessageToChat(sessionId, userInput, contentMessage.message, user.userId, sessionType, '', '', userMessageId, botMessageId);
      }
    } catch (error) {
      console.error('Error handling content writer data:', error);
      const { userMessageId, botMessageId } = generateMessageIds();
      const errorMessage = {
        id: uuidv4(),
        type: 'ai',
        message: `Error processing content writer results: ${error.message}`,
        time: new Date().toISOString(),
        bot_message_id: botMessageId
      };
      await sendMessageToChat(sessionId, userInput, errorMessage.message, user.userId, sessionType, '', '', userMessageId, botMessageId);
      setMessages((prev) => [...prev, errorMessage]);
    }
  };


  const handleLinkedInProfileScrapeData = async (responseData, sessionId, input) => {
    try {
        console.log('Handling LinkedIn profile scrape data:', responseData);

        // Extract the nested `data` object from the response
        const data = responseData.data.data;
        const linkedinUrl = responseData.linkedinUrl;

        // Ensure `data` is defined
        if (!data) {
            throw new Error('No profile data found in the response');
        }

        // Extract relevant data from the parsed JSON
        const {
            about: summary,
            certifications = [],
            educations = [],
            skills,
            first_name: firstName,
            last_name: lastName,
            headline,
            profile_image_url: profilePicture,
            location,
            experiences: jobs = [],
            geo,
        } = data;

        // Get current job (first item in jobs array since it's ordered by date)
        const currentPosition = jobs.find(job => job.is_current);

        // Format education information
        const formattedEducation = educations.map(school =>
            `${school.school}: ${school.degree} (${school.field_of_study})`
        ).join('\n');

        // Format skills with endorsement counts
        const formattedSkills = skills.split('|').map(skill => skill.trim()).join('\n');

        // Create a formatted message with the scraped profile data
        const profilePostData = {
            firstName,
            lastName,
            headline,
            summary,
            profilePicture,
            currentPosition,
            formattedEducation,
            formattedSkills,
            certifications,
            educations,
            positions: jobs,
            location: geo?.full || 'Location not available',
            linkedinUrl: linkedinUrl || 'LinkedIn URL not available'
        };

        

        // Create an AI message with the formatted profile data
        const aiMessage = {
            id: uuidv4(),
            type: 'ai',
            message: { linkedinProfileData: profilePostData },
            time: new Date().toISOString(),
            bot_message_id: generateMessageIds().botMessageId // Add this
        };
        console.log("aiMessage --->", aiMessage);

        // Update the messages state with the new AI message
        setMessages(prev => [...prev, aiMessage]);

        // Send the AI message to the chat
        await sendMessageToChat(sessionId, input, JSON.stringify(aiMessage.message), user.userId, sessionType, '', '', generateMessageIds().userMessageId, aiMessage.bot_message_id);

    } catch (error) {
        console.error('Error handling LinkedIn profile scrape data:', error);
       

        // Create an error message
        const errorMessage = {
            id: uuidv4(),
            type: 'ai',
            message: `Error processing LinkedIn profile data: ${error.message}`,
            time: new Date().toISOString(),
            bot_message_id: generateMessageIds().botMessageId // Add this
        };

        // Update the messages state with the error message
        setMessages(prev => [...prev, errorMessage]);
    }
};

  const handleCompanyProfileData = async (data, sessionId, userInput) => {
    console.log('Company data:', data, userInput);
    try {
      let newMessages = [];

      if (!data) {
        const { userMessageId, botMessageId } = generateMessageIds();
        const noDataMessage = {
          id: uuidv4(),
          type: 'ai',
          message: 'No company information found for the provided LinkedIn URL.',
          time: new Date().toISOString(),
          bot_message_id: botMessageId
        };
        newMessages.push(noDataMessage);
        await sendMessageToChat(sessionId, userInput, noDataMessage.message, user.userId, sessionType, '', '', userMessageId, botMessageId);
      } else {
        const { userMessageId, botMessageId } = generateMessageIds();
        const companyMessage = {
          id: uuidv4(),
          type: 'ai',
          message: {
            companyProfileData: data
          },
          time: new Date().toISOString(),
          bot_message_id: botMessageId
        };

        setMessages(prev => [...prev, companyMessage, ...newMessages]);

        // Send message to chat
        await sendMessageToChat(
          sessionId,
          userInput,
          JSON.stringify(companyMessage.message),
          user.userId,
          sessionType,
          '',
          '',
          userMessageId,
          companyMessage.bot_message_id
        );
      }

    } catch (error) {
      console.error('Error handling company data:', error);
      const { userMessageId, botMessageId } = generateMessageIds();
      const errorMessage = {
        id: uuidv4(),
        type: 'ai',
        message: `Error processing company information: ${error.message}`,
        time: new Date().toISOString(),
        bot_message_id: botMessageId  
      };
      await sendMessageToChat(sessionId, userInput, errorMessage.message, user.userId, sessionType, '', '', userMessageId, botMessageId);
      setMessages(prev => [...prev, errorMessage]);
    }
  };

  const handleSalesNavigatorResults = async (data, sessionId, userInput) => {
    console.log('Sales Navigator data:', data);
    try {

      if (data.data?.salesNavigatorQueueMessage) {
        const { userMessageId, botMessageId } = generateMessageIds();
        const queueMessage = {
          id: uuidv4(),
          type: 'ai',
          message: {
            salesNavigatorQueue: {
              message: data.data.salesNavigatorQueueMessage.message,
              requestId: data.data.salesNavigatorQueueMessage.request_id,
              searchUrl: data.searchUrl
            }
          },
          time: new Date().toISOString(),
          bot_message_id: botMessageId
        };
  
        setMessages(prev => [...prev, queueMessage]);
        await sendMessageToChat(
          sessionId,
          userInput,
          JSON.stringify(queueMessage.message),
          user.userId,
          sessionType,
          '',
          '',
          userMessageId,
          botMessageId
        );
        return;
      }
      // Validate data structure for normal results
      if (!data?.salesNavigatorData?.data || !Array.isArray(data.salesNavigatorData.data) || data.salesNavigatorData.data.length === 0) {
        const { userMessageId, botMessageId } = generateMessageIds();
        const noDataMessage = {
          id: uuidv4(),
          type: 'ai',
          message: 'No valid results found from Sales Navigator search.',
          time: new Date().toISOString(),
          bot_message_id: botMessageId
        };
        setMessages(prev => [...prev, noDataMessage]);
        await sendMessageToChat(sessionId, userInput, noDataMessage.message, user.userId, sessionType, '', '', userMessageId, botMessageId);
        return;
      }

      // Create messages with the search results and insights
      if (data.salesNavigatorData.data.length > 0) {
        // Generate unique message IDs for each message
        const { userMessageId: dataMessageUserId, botMessageId: dataMessageBotId } = generateMessageIds();
        const { userMessageId: promptMessageUserId, botMessageId: promptMessageBotId } = generateMessageIds();

        const messages = [
          {
            id: uuidv4(),
            type: 'ai',
            message: { salesNavigatorData: data.salesNavigatorData.data },
            time: new Date().toISOString(),
            bot_message_id: dataMessageBotId
          },
          {
            id: uuidv4(),
            type: 'ai',
            message: 'Select contact(s) to enrich',
            time: new Date().toISOString(),
            bot_message_id: promptMessageBotId
          }
        ];

        // Update UI state
        setMessages(prev => [...prev, ...messages]);

        // Send each message to chat separately with its own IDs
        await sendMessageToChat(
          sessionId,
          userInput,
          JSON.stringify(messages[0].message),
          user.userId,
          sessionType,
          '',
          '',
          dataMessageUserId,
          dataMessageBotId
        );

        await sendMessageToChat(
          sessionId,
          '',  // Empty userInput for the prompt message since it's a follow-up
          messages[1].message,
          user.userId,
          sessionType,
          '',
          '',
          promptMessageUserId,
          promptMessageBotId
        );
      }

    } catch (error) {
      console.error('Error handling Sales Navigator results:', error);
      const { userMessageId, botMessageId } = generateMessageIds();
      const errorMessage = {
        id: uuidv4(),
        type: 'ai',
        message: `Error processing Sales Navigator results: ${error.message}`,
        time: new Date().toISOString(),
        bot_message_id: botMessageId
      };
      setMessages(prev => [...prev, errorMessage]);
      await sendMessageToChat(sessionId, userInput, errorMessage.message, user.userId, sessionType, '', '', userMessageId, botMessageId);
    }
  };

  
  const handleGeneralPrompt = async (input, isFromReview = false) => {
    setIsTyping(true);
    try {
      let currentSessionId = activeSessionId;
      if (!currentSessionId) {
        currentSessionId = await createNewChat(user.userId, sessionType);
        setActiveSessionId(currentSessionId);
        navigate(`/chat/${currentSessionId}`, { replace: true });
      }

      // Only add the user message to the state if it's not from a review action
      if (!isFromReview) {
        const userMessage = {
          id: uuidv4(),
          type: 'human',
          message: input,
          time: new Date().toISOString()
          
        };
        setMessages(prev => [...prev, userMessage]);
      }

      const response = await handleGeneralConversation(input, currentSessionId);

      if (response.content) {
        const aiMessage = {
          id: uuidv4(),
          type: 'ai',
          message: response.content.content || response.content,
          time: new Date().toISOString()
        };

        // Check if the message contains a subject
        const hasSubject = checkForSubject(aiMessage.message);

        // Create an array of new messages to add
        const newMessages = [aiMessage];

        // If subject is found, add the follow-up question
        if (hasSubject) {
          newMessages.push({
            id: uuidv4(),
            type: 'ai',
            message: 'Would you like to add this step to sequence? (Yes/No)',
            time: new Date().toISOString()
          });
          setSequenceMode('yesno');
        }

        // Add all new messages to the state
        setMessages(prev => [...prev, ...newMessages]);

        // Refresh the recent chats list
        fetchRecentChats();
      } else {
        throw new Error('No content in response');
      }
    } catch (error) {
      console.error('Error processing general prompt:', error);
      setMessages(prev => [...prev, {
        id: uuidv4(),
        type: 'ai',
        message: `Error processing your request: ${error.message}`,
        time: new Date().toISOString()
      }]);
    } finally {
      setIsTyping(false);
      setReviewData(null);
    }
  };

  // Helper function to check if message contains a subject
  const checkForSubject = (message) => {
    try {
      // Case 1: If message is a string that can be parsed as JSON
      if (typeof message === 'string') {
        try {
          const parsedMessage = JSON.parse(message);
          // Check if parsed message has emailData with subject
          if (parsedMessage.emailData?.subject) {
            return true;
          }
          // Check if parsed message has content with subject
          if (parsedMessage.content?.includes('Subject:')) {
            return true;
          }
        } catch (e) {
          // If not JSON, check if string contains Subject:
          if (message.includes('Subject:')) {
            return true;
          }
        }
      }

      // Case 2: If message is already an object
      if (typeof message === 'object') {
        // Check direct emailData
        if (message.emailData?.subject) {
          return true;
        }
        // Check content property
        if (message.content?.includes('Subject:')) {
          return true;
        }
        // Check direct content for Subject:
        if (message.message?.includes('Subject:')) {
          return true;
        }
      }

      return false;
    } catch (error) {
      console.error('Error checking for subject:', error);
      return false;
    }
  };

  const handleTriggerEnrichment = (selectedContacts) => {
    setPeopleData(selectedContacts); // Store selected contacts
    setEnrichmentMode('type'); // Set mode directly to 'type' to skip yes/no
    const { userMessageId, botMessageId } = generateMessageIds();
    const questionMessage = {
      id: uuidv4(),
      type: 'ai',
      message: "How would you like to enrich the data? [EMAIL(E), phone(P), or both(B)]",
      time: new Date().toISOString(),
      bot_message_id: botMessageId
    };

    setMessages(prev => [...prev, questionMessage]);
    sendMessageToChat(activeSessionId, '', questionMessage.message, user.userId, sessionType, '', '', userMessageId, botMessageId);
  };

  const handleEnrichmentResponse = async (input, userMessage) => {
    const lowerInput = input.toLowerCase().trim();

    // Only create and send the user message once
    // const userMessage = { 
    //     id: uuidv4(), 
    //     type: 'user', 
    //     content: input, 
    //     time: new Date().toISOString() 
    // };

    // Batch the state updates to avoid race conditions
    let aiResponse = '';

    if (enrichmentMode === 'yesno') {
      if (lowerInput === 'yes') {
        aiResponse = "How would you like to enrich the data? [EMAIL(E), phone(P), or both(B)]";
        setEnrichmentMode('type');
      } else if (lowerInput === 'no') {
        aiResponse = 'Alright, no enrichment will be performed.';
        setEnrichmentMode(null);
      } else {
        aiResponse = "I'm sorry, I didn't understand that. answer with 'yes' or 'no'.";
      }
    } else if (enrichmentMode === 'type') {
      if (['email', 'phone', 'both'].includes(lowerInput)) {
        // aiResponse = `Starting enrichment process for ${lowerInput}...`;
        await performEnrichment(lowerInput, input);
        setEnrichmentMode(null);
      } else {
        aiResponse = "I'm sorry, I didn't understand that.  answer with 'email', 'phone', or 'both'.";
      }
    }
    const { userMessageId, botMessageId } = generateMessageIds();
    // Create AI message object
    const aiMessage = {
      id: uuidv4(),
      type: 'ai',
      message: aiResponse,
      time: new Date().toISOString(),
      bot_message_id: botMessageId
    };

    try {
      if (aiResponse) {
        // First update the local state with both messages
        setMessages(prev => [...prev, aiMessage]);
        await sendMessageToChat(activeSessionId, input, aiResponse, user.userId, sessionType, '', '', userMessageId, botMessageId);
        // await sendMessageToChat(activeSessionId, '', aiResponse, user.userId, sessionType);
      }


    } catch (error) {
      console.error('Error handling enrichment response:', error);
      // Handle error appropriately
    }
  };

  const generateUniqueId = () => {
    return `id-${Date.now()}-${Math.floor(Math.random() * 10000)}`;
  };

  const handleSaveContacts = useCallback((contacts) => {
    // Implement the logic to save contacts to OnePageR
    console.log('Saving contacts to OnePgr:', contacts);
    // You can add an API call here to save the contacts
  }, []);

  const performEnrichment = async (enrichmentType, input) => {
    setIsTyping(true);
    try {
      if (!peopleData) {
        throw new Error("No people data available for enrichment");
      }
  
      const response = await enrichPeopleData(peopleData, enrichmentType);
      console.log("enrich people response --->", response);
  
      if (response.success && response.data?.enriched_people) {
        const updatedPeopleData = response.data.enriched_people.map(enrichedPerson => {
          // Parse location if available
          const locationParts = enrichedPerson.location?.split(', ') || [];
          
          // Handle organization/company data
          const company = enrichedPerson.organization || {};
          
          return {
            // Basic Information
            id: enrichedPerson.profile_id || enrichedPerson.id || generateUniqueId(),
            first_name: enrichedPerson.first_name || enrichedPerson.name?.split(',')[0] || '',
            last_name: enrichedPerson.last_name || enrichedPerson.name?.split(',')[1]?.trim() || '',
            name: enrichedPerson.full_name || enrichedPerson.name || `${enrichedPerson.first_name || ''} ${enrichedPerson.last_name || ''}`.trim(),
            title: enrichedPerson.title || enrichedPerson.headline || '',
            headline: enrichedPerson.headline || '',
            seniority: enrichedPerson.seniority || null,
            departments: enrichedPerson.departments || [],
            functions: enrichedPerson.functions || [],
            subdepartments: enrichedPerson.subdepartments || [],

            // Location Information
            city: enrichedPerson.city || locationParts?.[0] || '',
            state: enrichedPerson.state || locationParts?.[1] || '',
            country: enrichedPerson.country || locationParts?.[2] || '',

            // Contact Information
            email: enrichedPerson.enriched_email || "email_not_unlocked@domain.com",
            phone: enrichedPerson.enriched_phone || null,
            email_status: enrichedPerson.enriched_email ? "verified" : "unverified",
            email_domain_catchall: false,

            // Company Information
            company: company?.name || enrichedPerson.company || '',
            company_domain: company?.primary_domain || enrichedPerson.company_domain || '',
            company_size: company?.size || enrichedPerson.company_employee_range || '',
            company_industry: company?.industry || enrichedPerson.company_industry || '',
            company_linkedin_url: company?.linkedin_url || enrichedPerson.company_linkedin_url || '',
            company_website: company?.website_url || enrichedPerson.company_website || '',
            company_founded: company?.founded_year || enrichedPerson.company_year_founded || '',
            company_market_cap: company?.market_cap || null,
            company_social: {
              facebook: company?.facebook_url || null,
              twitter: company?.twitter_url || null,
              linkedin: company?.linkedin_url || null
            },

            // Social Media & Profile Links
            linkedin_url: enrichedPerson.linkedin_url || enrichedPerson.profileLink || '',
            profile_image_url: enrichedPerson.photo_url || enrichedPerson.profile_image_url || '',
            
            // Education & Experience
            education: enrichedPerson.educations || [],
            employment_history: enrichedPerson.employment_history || enrichedPerson.experiences || [],
            
            // Additional Profile Info
            about: enrichedPerson.about || '',
            source: enrichedPerson.source || '',
            post_url: enrichedPerson.postUrl || '', // Added for new response format
            timestamp: enrichedPerson.timestamp || new Date().toISOString(), // Added for new response format

            // Engagement Metrics
            is_likely_to_engage: true,
            revealed_for_current_team: true,
            show_intent: true,
            intent_strength: null,
            extrapolated_email_confidence: null
          };
        });
  
        updatedPeopleData.forEach(person => {
          person['id2'] = generateUniqueId();
        });
  
        // Add enrichment result analysis
        const enrichmentResults = {
          totalPeople: updatedPeopleData.length,
          validEmails: 0,
          validPhones: 0
        };
  
        updatedPeopleData.forEach(person => {
          if (person.email && person.email !== "email_not_unlocked@domain.com" && person.email !== "Email not found") {
            enrichmentResults.validEmails++;
          }
          if (person.receiver_number) {
            enrichmentResults.validPhones++;
          }
        });
  
        // Generate appropriate message based on enrichment type and results
        let enrichmentMessage = '';
        if (enrichmentType.toLowerCase() === 'email') {
         
          // Count successful and failed enrichments with their sources
          const enrichmentDetails = updatedPeopleData.reduce((acc, person) => {
            if (person.enriched_email && person.enriched_email !== "Email not found") {
              if (person.source !== "none") {
                acc.successful.push({
                  name: person.enriched_name || `${person.first_name} ${person.last_name}`,
                  source: person.source
                });
              }
            } else {
              acc.failed.push(person.enriched_name || `${person.first_name} ${person.last_name}`);
            }
            return acc;
          }, { successful: [], failed: [] });
  
          if (enrichmentResults.validEmails === 0) {
            enrichmentMessage = 'No valid emails were found during enrichment.';
          } else {
            let successMessage = '';
            if (enrichmentResults.validEmails === 1) {
              if (enrichmentDetails.successful.length > 0) {
                const { name, source } = enrichmentDetails.successful[0];
                successMessage = `Successfully enriched email for ${response.data.enriched_people[0].enriched_name} using ${response.data.enriched_people[0].source}`;
              } else {
                successMessage = `Successfully enriched email for 1 contact `;
              }
            } else {
              console.log("enrichmentDetails.successful --->", enrichmentDetails.successful)
              const sources = [...new Set(enrichmentDetails.successful.map(s => s.source))].join(' and ');
              successMessage = `Successfully enriched emails for ${enrichmentResults.validEmails} contacts.`;
            }
  
            let failureMessage = '';
            if (enrichmentDetails.failed.length > 0) {
              failureMessage = `\nCould not enrich ${enrichmentDetails.failed.length} contact${enrichmentDetails.failed.length > 1 ? 's' : ''} (tried multiple sources)`;
            }
  
            enrichmentMessage = `${successMessage}\nYou can select and save the enriched contact${enrichmentResults.validEmails > 1 ? 's' : ''} to OnePgr using the 'Save to OnePgr' button.`;
          }
        } else if (enrichmentType.toLowerCase() === 'phone') {
          if (enrichmentResults.validPhones === 0) {
            enrichmentMessage = 'No valid phone numbers were found during enrichment.';
          } else if (enrichmentResults.validPhones === 1) {
            const source = updatedPeopleData[0].source || 'multiple sources';
            enrichmentMessage = `Successfully enriched 1 contact with phone number using ${source}. Would you like to save this contact to OnePgr?`;
          } else {
            const source = updatedPeopleData[0].source || 'multiple sources';
            enrichmentMessage = `${enrichmentResults.validPhones} contacts enriched with phone numbers using ${source}. Would you like to save these contacts to OnePgr?`;
          }
        } else if (enrichmentType.toLowerCase() === 'both') {
          const source = updatedPeopleData[0].source || 'multiple sources';
          if (enrichmentResults.totalPeople === 1) {
            let details = [];
            if (enrichmentResults.validEmails > 0) details.push('email');
            if (enrichmentResults.validPhones > 0) details.push('phone number');
            
            if (details.length === 0) {
              enrichmentMessage = 'No valid email or phone number was found for this contact.';
            } else {
              enrichmentMessage = `Successfully enriched 1 contact with ${details.join(' and ')} using ${source}. Would you like to save this contact to OnePgr?`;
            }
          } else {
            enrichmentMessage = `Enrichment results from ${source}:\n` +
              `${enrichmentResults.validEmails > 0 ? `- ${enrichmentResults.validEmails} emails found\n` : '- No valid emails found\n'}` +
              `${enrichmentResults.validPhones > 0 ? `- ${enrichmentResults.validPhones} phone numbers found\n` : '- No valid phone numbers found\n'}` +
              `Would you like to save ${enrichmentResults.totalPeople > 1 ? 'these contacts' : 'this contact'} to OnePgr?`;
          }
        }
  
        console.log("updated people data--->", updatedPeopleData);
        setEnrichedPeopleData(updatedPeopleData);
        setIsEnriched(true);
        
        const { userMessageId, botMessageId } = generateMessageIds();
        const dataMessage = {
          id: uuidv4(),
          type: 'ai',
          message: { enrichedPeopleData: updatedPeopleData },
          time: new Date().toISOString(),
          bot_message_id: botMessageId
        };
  
        const successMessage = {
          id: uuidv4(),
          type: 'ai',
          message: enrichmentMessage,
          time: new Date().toISOString(),
          bot_message_id: generateMessageIds().botMessageId
        };
  
        await sendMessageToChat(
          activeSessionId,
          input,
          JSON.stringify(dataMessage.message),
          user.userId,
          sessionType,
          '',
          '',
          userMessageId,
          botMessageId
        );
  
        setMessages(prev => [...prev, dataMessage, successMessage]);
      } else {
        throw new Error(response.error || 'Unknown error occurred during enrichment');
      }
    } catch (error) {
      console.error('Error enriching data:', error);
      const { userMessageId, botMessageId } = generateMessageIds();
      const errorMessage = {
        id: uuidv4(),
        type: 'ai',
        message: `Error enriching data: ${error.message}`,
        time: new Date().toISOString(),
        bot_message_id: botMessageId
      };
      setMessages(prev => [...prev, errorMessage]);
    } finally {
      setIsTyping(false);
      setEnrichmentMode(null);
    }
  };

  const handleEditMessage = (messageId) => {
    console.log('Editing message:', messageId);
    setEditingMessageId(messageId);
  };

  const handleCancelEdit = () => {
    setEditingMessageId(null);
  };

  const handleSaveEdit = async (messageId, editedContent) => {
    console.log('Saving edited message:', messageId, editedContent);
    setMessages(prev => prev.map(msg =>
      msg.id === messageId ? { ...msg, message: editedContent } : msg
    ));
    setEditingMessageId(null);

    // Reprocess the edited message
    await handleSendMessage(editedContent);
  };

  const getAvatarContent = () => {
    console.log('user----->', user)
    if (!user) return '';
    if (user.profilePic) return <img src={user.profilePic} alt="User avatar" className="user-avatar-img" />;
    return user.name.charAt(0).toUpperCase();
  };

  const handleToggleWelcomeMessage = () => {
    setShowWelcomeMessage(!showWelcomeMessage);
  };

  const handleSequenceCreation = async (input, userMessage) => {
    let identificationMessage;
    const lowerInput = input.toLowerCase().trim();
    // const userMessage = { id: uuidv4(), type: 'user', content: input, time: new Date().toISOString() };
    // setMessages(prev => [...prev, userMessage]);
    // await sendMessageToChat(activeSessionId, input, userMessage, user.userId, sessionType);
    let aiMessage;
    if (sequenceMode === 'yesno') {
      if (lowerInput === 'yes') {
        const { userMessageId, botMessageId } = generateMessageIds();
        aiMessage = {
          id: uuidv4(),
          type: 'ai',
          message: "How would you like to add this step? [new sequence(N) or existing sequence(E)]",
          time: new Date().toISOString(),
          bot_message_id: botMessageId
        };
        setSequenceMode('type');

      } else if (lowerInput === 'no') {
        const { userMessageId, botMessageId } = generateMessageIds();
        aiMessage = {
          id: uuidv4(),
          type: 'ai',
          message: 'Alright, no sequence creation will be performed.',
          time: new Date().toISOString(),
          bot_message_id: botMessageId
        };
        setSequenceMode(null);
      } else {
        aiMessage = {
          id: uuidv4(),
          type: 'ai',
          message: "I'm sorry, I didn't understand that.  answer with 'yes' or 'no'.",
          time: new Date().toISOString()
        };
      }
    } else if (sequenceMode === 'type') {
      if (['new', 'existing', 'new sequence', 'existing sequence'].includes(lowerInput)) {
        // let newMessages = [];
        //     newMessages.push({
        //       id: uuidv4(),
        //       type: 'ai',
        //       content: `Started adding this step for ${lowerInput}...`,
        //     });
        //   setMessages(prev => [...prev, ...newMessages]);
        if (lowerInput === 'new sequence' || lowerInput === 'new') {
          const seqData = await createAutomatedSequence();
          console.log('seqData----->', JSON.parse(seqData.response))
          const newListData = JSON.parse(seqData.response);
          setSelectedSequenceList(newListData)
          let stepNum = 1;
          if (newListData.success == '0') {
            console.log('user--->', user)
            const emailStepDatapayload = [];
            const allStepsResp = []
            for (let index = 0; index < emailStep.length; index++) {
              const step = emailStep[index];
              let emailStepData = getEmailStepFormData(newListData.list_id, stepNum, step)
              const payLoadData = {}
              emailStepData.forEach((value, key) => {
                payLoadData[key] = value;
              });
              emailStepDatapayload.push(payLoadData)
              const stepResp = await AddStepToExistingSequence(emailStepData);
              allStepsResp.push(stepResp)
              stepNum = stepNum + 1
            }
            console.log('stepResp---->', allStepsResp)
            const listViewDtls = {
              message: 'Email step added successfully to new sequence',
              list_id: newListData.list_id
            }
            identificationMessage = 'Email step added successfully to new sequence'
            aiMessage = {
              id: uuidv4(),
              type: 'ai',
              message: { newlyCreatedSequence: listViewDtls },
              time: new Date().toISOString()
            };
          }

        }
        else if (lowerInput === 'existing sequence' || lowerInput === 'existing') {
          const sequenceList = await getAutomatedSequenceList();
          console.log('sequenceList-->', sequenceList);
          if (sequenceList.success == '0') {
            setAutomatedSequenceList(sequenceList)
            const sequenceListMessage = {
              id: uuidv4(),
              type: 'ai',
              message: { sequenceList: sequenceList },
              time: new Date().toISOString()
            };
            // await sendMessageToChat(activeSessionId, input, JSON.stringify(sequenceListMessage.message), user.userId, sessionType);

            setMessages(prev => [...prev, sequenceListMessage]);
          }
        }

        setSequenceMode(null);
      } else {
        aiMessage = {
          id: uuidv4(),
          type: 'ai',
          message: "I'm sorry, I didn't understand that.  answer with 'new sequence' or 'existing sequence'.",
          time: new Date().toISOString()
        };
      }
    }

    if (aiMessage) {
      await sendMessageToChat(activeSessionId, input, aiMessage.message, user.userId, sessionType);
      setMessages(prev => [...prev, aiMessage]);
      if (identificationMessage === 'Email step added successfully to new sequence') {
        console.log('selectedSequenceList----->', selectedSequenceList)
        const dropSeqMessage = {
          id: uuidv4(),
          type: 'ai',
          message: 'Would you like to Drop/Execute this sequence?  (Yes/No)'
        };
        setDropSequenceMode('yesno');
        // await sendMessageToChat(activeSessionId, '', dropSeqMessage.message, user.userId, sessionType);
        setMessages(prev => [...prev, dropSeqMessage]);
      }
    }
  }

  const handleEngageSequenceForLatestContactsList = async (input, userMessage) => {
    const lowerInput = input.toLowerCase().trim();
    let aiMessage;
    let conditions1 = ['use existing sequence', 'existing sequence']
    let conditions2 = ['create an email', 'create a email', 'create email', 'email']
    if (engageSequenceMode === 'yesno') {
      if (conditions1.includes(lowerInput)) {
        console.log('Call api to get list of sequences')
        const sequenceList = await getAutomatedSequenceList();
        console.log('sequenceList-->', sequenceList);
        if (sequenceList.success == '0') {
          setAutomatedSequenceList(sequenceList)
          const sequenceListMessage = {
            id: uuidv4(),
            type: 'ai',
            message: { sequenceList: sequenceList, isFromSequenceExe: 'engageSequenceForLatestContactList' },
            time: new Date().toISOString(),
            bot_message_id: generateMessageIds().botMessageId
          };
          setMessages(prev => [...prev, sequenceListMessage]);
          setEngageSequenceMode(null);
        }
      } else if (conditions2.includes(lowerInput)) {
        aiMessage = {
          id: uuidv4(),
          type: 'ai',
          message: "How would you like to create an email? 'Standalone Email [S]' or 'Create a Sequence [C]' ",
          time: new Date().toISOString(),
          bot_message_id: generateMessageIds().botMessageId
        };
        setMessages(prev => [...prev, aiMessage]);
        setEngageSequenceMode('createEmial/createSequence');
      } else {
        aiMessage = {
          id: uuidv4(),
          type: 'ai',
          message: "I'm sorry, I didn't understand that. answer with 'Create an Email' or 'Existing Sequence'",
          time: new Date().toISOString(),
          bot_message_id: generateMessageIds().botMessageId
        };
        setMessages(prev => [...prev, aiMessage]);
        // setEngageSequenceMode(null);
      }
    } else if (engageSequenceMode === 'createEmial/createSequence') {
      const consitionArr1 = ['standalone email', 'standalone', 'email']
      const consitionArr2 = ['create a sequence', 'create sequence', 'create', 'sequence']
      if (consitionArr1.includes(lowerInput)) {
        aiMessage = {
          id: uuidv4(),
          type: 'ai',
          message: `Enter a prompt to create a standalone email.
            Ex: Create a standalone email regarding VPs of Marketing focusing on AI adoption`,
          time: new Date().toISOString(),
          bot_message_id: generateMessageIds().botMessageId
        };
        setMessages(prev => [...prev, aiMessage]);
        setEngageSequenceMode(null);
      } else if (consitionArr2.includes(lowerInput)) {
        aiMessage = {
          id: uuidv4(),
          type: 'ai',
          message: `Enter a prompt to create a seqeunce.
            Ex: Create a sequence for VPs of Marketing focusing on AI adoption using email`,
          time: new Date().toISOString(),
          bot_message_id: generateMessageIds().botMessageId
        };
        setMessages(prev => [...prev, aiMessage]);
        setEngageSequenceMode(null);
      } else {
        aiMessage = {
          id: uuidv4(),
          type: 'ai',
          message: "I'm sorry, I didn't understand that. answer with 'Standalone Email' or 'Create Sequence'",
          time: new Date().toISOString(),
          bot_message_id: generateMessageIds().botMessageId
        };
        setMessages(prev => [...prev, aiMessage]);
      }
    }
  }

  const handleDropSequence = async (input, userMessage) => {
    const lowerInput = input.toLowerCase().trim();
    let aiMessage;
    if (dropSequenceMode === 'yesno') {
      if (lowerInput === 'yes') {
        console.log('call contact list api and show list of contact lists')
        const resp = await getOnepgrContactLists();
        if (resp && resp.success == '0') {
          console.log('conatct list---->', resp.response.lists_listing);
          const selectListMsg = {
            id: uuidv4(),
            type: 'ai',
            message: { selectContactList: resp.response.lists_listing },
            time: new Date().toISOString()
          };
          setDropSequenceMode(null);
          setMessages(prev => [...prev, selectListMsg]);
        }
      } else if (lowerInput === 'no') {
        aiMessage = {
          id: uuidv4(),
          type: 'ai',
          message: 'Alright, no sequence execution will be performed.',
          time: new Date().toISOString(),
          bot_message_id: generateMessageIds().botMessageId
        };
        setMessages(prev => [...prev, aiMessage]);
        setDropSequenceMode(null);
      } else {
        aiMessage = {
          id: uuidv4(),
          type: 'ai',
          message: "I'm sorry, I didn't understand that. answer with 'yes' or 'no'.",
          time: new Date().toISOString(),
          bot_message_id: generateMessageIds().botMessageId
        };
      }
    }
  }

  const handleSelectedContactList = (selectedContactList) => {
    console.log('selectedContactList---->', selectedContactList)
    console.log('Show user to selected drop to schedule contacts')
    setSelectedContactList(selectedContactList)
    const selectListMsg = {
      id: uuidv4(),
      type: 'ai',
      message: { selectDropTime: 'Droptime' },
      time: new Date().toISOString(),
      bot_message_id: generateMessageIds().botMessageId
    };
    setDropSequenceMode(null);
    setMessages(prev => [...prev, selectListMsg]);
  }

  const handleSaveToOnepgrContactlist = (contactList_id) => {
    console.log('contactList_id---->', contactList_id);
    currentContactList_idRef.current = contactList_id;
    const sequenceEngageMessage = {
      id: uuidv4(),
      type: 'ai',
      message: "Would you like to [Create an Email (C) or Use Existing Sequence (E)]?",
      time: new Date().toISOString(),
      bot_message_id: generateMessageIds().botMessageId
    };
    setEngageSequenceMode('yesno');
    setMessages(prev => [...prev, sequenceEngageMessage]);
    setTimeout(() => {
      setAutoScroll(true)
    }, 1000);
  }

  const handleSelectDropTime = async (selectedDropTime) => {
    console.log('selectedSequenceList----------->', selectedSequenceList)
    const contactlist_id = selectedContactList ? selectedContactList.list_id : currentContactList_idRef.current;;
    const sequenceListId = selectedSequenceList.list_id;
    let allContactActions = [];
    // const contactlist_id = '8338';
    // const sequenceListId = '8376';
    const dropId = window.btoa(Date.now().toString());
    let contactListData = []
    let actionBlockListData = []
    let actionBlockSteps = []
    setIsTyping(true);
    console.log('dropId---->', dropId)
    console.log('selectedDropTime---->', selectedDropTime, contactlist_id)
    console.log('Schedue contacts with selected droptime', sequenceListId)
    try {
      const userDetailsResp = await getProfileAttributes(user.userId);
      console.log('userDetails---->', JSON.parse(userDetailsResp))
      setUserDetails(JSON.parse(userDetailsResp));

      const sequenceListResp = await getAutomatedSequenceListDetails(sequenceListId);
      let sequenceData = JSON.parse(sequenceListResp);
      sequenceData['list_flags'] = JSON.parse(sequenceData['list_flags']);
      console.log('sequenceData---->', sequenceData)
      const contactListResp = await getContactsFromConactList(contactlist_id);
      console.log('contactListResp---->', contactListResp)
      contactListData = contactListResp.contacts_list
      console.log('contactListData---->', contactListData)
      const actionBlockListResp = await getSequenceLevelActionBlocks(sequenceListId);
      actionBlockListData = actionBlockListResp.actionblock_list;
      console.log('actionBlockListData--->', actionBlockListData)
      for (let i = 0; i < actionBlockListData.length; i++) {
        const actionBlock = actionBlockListData[i];
        const actionStepResp = await getActionBlockDetails(actionBlock.actionblock_id);
        actionBlockSteps.push(JSON.parse(actionStepResp));
      }
      console.log('actionBlockSteps---->', actionBlockSteps)
      for (let i = 0; i < actionBlockSteps.length; i++) {
        const actionBlock = actionBlockSteps[i];
        await createContactActionSequenceforBatch(contactListData, dropId, actionBlock, selectedDropTime, sequenceData, JSON.parse(userDetailsResp), allContactActions);
      }
      // await createAndScheduleEmails(sequenceData,dropId,allContactActions,selectedDropTime,contactListData);
      scheduledCotactionsRef.current = {
        sequenceData: sequenceData,
        dropId: dropId,
        allContactActions: allContactActions,
        selectedDropTime: selectedDropTime,
        contactListData: contactListData
      }
      setIsTyping(false);
      toggleSequenceReviewModal(true)
    } catch (error) {
      console.log('error in sequence drop---->', error);
      setIsTyping(false);
      const errorMessage = {
        id: uuidv4(),
        type: 'ai',
        message: "Sequence Execution failed",
        time: new Date().toISOString(),
        bot_message_id: generateMessageIds().botMessageId
      };
      setMessages(prev => [...prev, errorMessage]);
      toggleSequenceReviewModal(false)
    }
  }

  const createContactActionSequenceforBatch = async (dropContacts, dropId, actionBlock, scheduledDropTime, sequenceData, userDtls, allContactActions) => {
    console.log('sequenceData------------->', sequenceData)
    let tempTime = scheduledDropTime;
    let runningDropTime;
    let openAiMails = [];
    let currentAppAccount = user.userId === '4991' ? senderAppAccounts[1] : senderAppAccounts[0];
    let sequenceUnblockedContacts = dropContacts.filter(
      (contact) => contact.autom_seq_disabled != 1
    );
    for (let i = 0; i < sequenceUnblockedContacts.length; i++) {
      let contactDetails = sequenceUnblockedContacts[i];
      const actionBlockDetails = { ...actionBlock };
      actionBlockDetails["user_id"] = user.userId;
      if (actionBlockDetails.msg_subject) {
        actionBlockDetails.msg_subject = formatMessageTitle(actionBlockDetails, contactDetails);
      }
      if (actionBlockDetails.msg_body && sequenceData.email_engine == 2) {
        actionBlockDetails.msg_body = await formatMessageBody(
          actionBlockDetails,
          contactDetails
        );
      }
      if (actionBlockDetails.genai_flag == 1) {
        let response = await generateAIContent(
          actionBlockDetails.msg_body,
          actionBlockDetails.genai_msg_flag == 1
        );
        if (response) {
          if (actionBlockDetails.genai_msg_flag == 1) {
            actionBlockDetails.msg_subject = response.msg_subject
              .replace(/Subject:/g, "")
              .replace(/<\/p>/g, "")
              .replace(/<strong> /g, "")
              .replace(/<\/strong> /g, "")
              .replace(/<p>/g, "")
              .replace(/<\/b>:/g, "")
              .replace(/<b>:/g, "")
              .replace(/Subject Line:/g, "");
            actionBlockDetails.msg_body = response.msg_body;
          } else actionBlockDetails.msg_body = response;
          // if(sequenceData.email_engine == 1) {
          //   this.mktgMessage=actionBlockDetails.msg_body
          // }
        } else {
          // this.customToastrService.error(
          //   `An unexpected error occured while generating message for ${contactDetails.firstname}. Skipping and Continuing`
          // );
          // this.respCount++;
          // this.totalItemsDropped++;
          // continue;
          console.log('In genai else')
        }
      }
      // if (
      //   actionBlockDetails.parent_thread_id &&
      //   actionBlockDetails.parent_thread_id != "null" &&
      //   actionBlockDetails.parent_thread_id != "undefined"
      // ) {
      //   actionBlockDetails.msg_body = await getFollowUpBody(
      //     actionBlockDetails,
      //     contactDetails
      //   );
      //   actionBlockDetails.msg_subject = await getFollowUpBody( 
      //     actionBlockDetails,
      //     contactDetails,
      //     true
      //   );
      // }
      let contactOffset = sequenceData.email_engine == 2 ? 1 : 0;
      runningDropTime = tempTime = moment(tempTime)
        .local()
        .add(contactOffset, "minutes")
        .utc()
        .toString();
      if (sequenceData.email_engine == 2 && actionBlockDetails.type === "email") {
        tempTime = runningDropTime;
        // this.getDailyDropCount(this.runningDropTime,actionBlockDetails.type);
        // tempTime = runningDropTime;
      }
      actionBlockDetails["step_drop_id"] = dropId;
      actionBlockDetails["step_drop_type"] = user.userId === "" ? "immediate" : "scheduled";
      actionBlockDetails.contact_id = contactDetails.contact_id;
      actionBlockDetails.action_type = actionBlockDetails.type;
      actionBlockDetails.drop_time = runningDropTime;
      actionBlockDetails.user_id = userDtls.user_id;
      actionBlockDetails.sender_name = userDtls.user_name;
      actionBlockDetails.sender_email = userDtls.user_email;
      actionBlockDetails.receiver_email = contactDetails.email;
      actionBlockDetails.sender_number = userDtls.purch_phone_no;
      actionBlockDetails.account_id = contactDetails.account_id;
      actionBlockDetails.receiver_number = contactDetails.mobile
        ? contactDetails.mobile
        : contactDetails.phone;
      actionBlockDetails.description = currentAppAccount ? currentAppAccount.app_account_id : '';
      actionBlockDetails.firstname = contactDetails.firstname;
      actionBlockDetails.lastname = contactDetails.lastname;
      actionBlockDetails.email = contactDetails.email;
      actionBlockDetails.crm_object_value = contactDetails.crm_object_value;
      actionBlockDetails.tags = contactDetails.tags;
      actionBlockDetails.job_queued = "1";
      actionBlockDetails.sdr_owner = currentAppAccount ? currentAppAccount.app_username : '';
      let recipientJsonObj = {}
      actionBlockDetails.recipient_json = JSON.stringify(recipientJsonObj);
      if (actionBlockDetails.msg_body || this.sequenceData.email_engine == 1) {
        // if (actionBlockDetails.type && actionBlockDetails.type === "sms") {
        //   let mobileNumbersArray = await this.mobileNumberCheckup(
        //     contactDetails
        //   );
        //   for (let index = 0; index < mobileNumbersArray.length; index++) {
        //     const number = mobileNumbersArray[index].number;
        //     actionBlockDetails.receiver_number = number;
        //     this.allContactActions.push(actionBlockDetails);
        //   }
        //   this.respCount++;
        //   this.totalItemsDropped++;
        // } else {
        // this.respCount++;
        // this.totalItemsDropped++;
        allContactActions.push(actionBlockDetails);
        // }
        if (actionBlockDetails.genai_flag == 1) {
          openAiMails.push(actionBlockDetails)
        }
      }
    }
    // await createAndScheduleEmails(sequenceData,dropId,allContactActions,scheduledDropTime,dropContacts)

  }

  async function createAndScheduleEmails(sequenceData, drop_id, allContactActions, scheduledDropTime, dropContacts) {
    // this.isLoading = true;
    // this.insertAndUpdateDropDates();
    console.log('allContactActions---->', allContactActions)
    let res
    if (sequenceData.email_engine == 2) {
      res = await createAndScheduleContactAction(allContactActions, sequenceData.email_engine, sequenceData.list_flags.advLinkTracking)
    }
    // else{
    //   await this.scheduleCronJob(drop_id);
    //   res = createAndScheduleMarketingCampaign(allContactActions,sequenceData.email_engine,this.mktgMessage,this.sequenceData.listFlags.advLinkTracking)
    //   .toPromise();
    // }
    if (res.status == 0) {
      // this.customToastrService.success(
      //   `${this.emails.length} Contact${
      //     this.emails.length > 1 ? "s" : ""
      //   } submitted for Automated Sequence`
      // );
      // this.close();
      // this.isLoading = false;
      console.log('res--->', res);
      const newMessage = {
        id: uuidv4(),
        type: 'ai',
        message: { viewSequenceReport: sequenceData },
        time: new Date().toISOString(),
        bot_message_id: generateMessageIds().botMessageId
      };
      setMessages(prev => [...prev, newMessage]);
    } else {
      // this.close();
      // this.isLoading = false;
      // this.customToastrService.error("An error occured");
      console.log('An error occured--->', res)
      const errorMessage = {
        id: uuidv4(),
        type: 'ai',
        message: "Sequence Execution failed",
        time: new Date().toISOString(),
        bot_message_id: generateMessageIds().botMessageId
      };
      setMessages(prev => [...prev, errorMessage]);
    }
    // if(sequenceHistory)
    await createSequenceHistory(sequenceData, allContactActions, scheduledDropTime, dropContacts)
  }

  async function createSequenceHistory(sequenceData, allContactActions, scheduledDropTime, dropContacts) {
    let payLoad = {
      list_id: sequenceData.list_id,
      date: new Date(),
      first_contact_email: allContactActions[0].receiver_email,
      last_contact_email: allContactActions[allContactActions.length - 1].receiver_email,
      notes: "",
      drop_time: scheduledDropTime,
      type: "drop",
      total_contacts_added: dropContacts.length,
      contacts_lists: ""
    };
    await createSequenceHistoryApi(payLoad)
  }

  async function generateAIContent(msg_body, withSubject) {
    msg_body = msg_body + " Requirement: Email without subject line";
    // Generate a response using OpenAI's API.
    let msg_response = await generateOpenAiResponse(msg_body, 0, { userId: user.userId })
    console.log('msg_response--->', msg_response)
    if (msg_response.status == 0) {
      // If the response was successful, proceed to generate a subject line (if required).
      if (withSubject) {
        let sub_prompt =
          "Write a subject line for the following message: \n\n<br>" +
          msg_response.data;
        let subject_response = generateOpenAiResponse(sub_prompt, 1, { userId: user.userId })
        // If the subject line was generated successfully, return the message body and subject line.
        if (subject_response.status == 0) {
          return {
            msg_body: msg_response.data
              .replace(/<p>/g, "")
              .replace(/<\/p>/g, ""),
            msg_subject: subject_response.data
              .replace(/<p>/g, "")
              .replace(/<\/p>/g, "")
              .replace(/<br>/g, "")
              .replace(/<\/br>/g, "")
              .replace(/<br \/>/g, ""),
          };
        } else return null;
      } else {
        // If a subject line is not required, return just the message body.
        return msg_response.data.replace(/<p>/g, "").replace(/<\/p>/, "");
      }
    } else return null;
  }


  function formatMessageTitle(actionBlockDetails, contactDetails) {
    actionBlockDetails.msg_subject = actionBlockDetails.msg_subject
      .replace(/{{CompanyName}}/g, contactDetails.company)
      .replace(/{{FirstName}}/g, contactDetails.firstname)
      .replace(/{{LastName}}/g, contactDetails.lastname)
      .replace(/{{LinkedInURL}}/g, contactDetails.linkedin)
      .replace(/{{CompanyURL}}/g, contactDetails.company_url)
      // .replace(/{{Signature}}/g, this.userService.emailSignature)
      // .replace(/{{SenderName}}/g, this.senderName)
      // .replace(/{{SenderSignature}}/g, this.senderSignature)
      // .replace(/{{Title}}/g, contactDetails.title)
      // .replace(/{{VideoSignature}}/g, this.userService.videoSignature)
      .replace(/{{IceBreaker}}/g, "");
    return actionBlockDetails.msg_subject;
  }

  async function formatMessageBody(actionBlockDetails, contactDetails) {
    if (contactDetails.custom_fields_json) {
      let customFields = JSON.parse(contactDetails.custom_fields_json)
      Object.keys(customFields).forEach((key) => {
        let macro = `{{${key}}}`;
        actionBlockDetails.msg_body = actionBlockDetails.msg_body.replace(new RegExp(macro, 'g'), customFields[key])
      })
    }
    actionBlockDetails.msg_body = actionBlockDetails.msg_body
      .replace(/{{CompanyName}}/g, contactDetails.company)
      .replace(/{{FirstName}}/g, contactDetails.firstname)
      .replace(/{{LastName}}/g, contactDetails.lastname)
      .replace(/{{City}}/g, contactDetails.co_city)
      .replace(/{{Title}}/g, contactDetails.title)
      .replace(/{{LinkedInURL}}/g, contactDetails.linkedin)
      .replace(/{{CompanyURL}}/g, contactDetails.company_url)
      .replace(/{{State}}/g, contactDetails.add_state)   // for company state, co_street@ is used
      // .replace(/{{Signature}}/g, this.userService.emailSignature)
      // .replace(/{{SenderName}}/g, this.senderName)
      // .replace(/{{SenderSignature}}/g, this.senderSignature)
      // .replace(/{{VideoSignature}}/g, this.userService.videoSignature)
      .replace(/{{IceBreaker}}/g, "");
    // if (groupEmailEnabled) {
    //   if(salutation == 0){
    //     const firstnames = this.selectedContactDetails.map(
    //     (contact) => contact.firstname);
    //   let groupString = firstnames.join(", ");
    //   groupString = groupString.replace(/,([^,]*)$/, ' and$1');
    //   actionBlockDetails.msg_body = actionBlockDetails.msg_body.replace(
    //     /{{FirstName}}/g, groupString);
    //   }
    //   else actionBlockDetails.msg_body = actionBlockDetails.msg_body.replace(
    //     /{{FirstName}}/g, 'All');
    // } 
    actionBlockDetails.msg_body = actionBlockDetails.msg_body.replace(/{{FirstName}}/g, contactDetails.firstname)

    // if (actionBlockDetails.msg_doc_url) {
    //   var res = actionBlockDetails.msg_doc_url.split(",");

    //   for (let i = 0; i < res.length; i++) {
    //     const url = res[i];
    //     if (url != "") {
    //       if (url.includes("doc-item/")) {
    //         if (actionBlockDetails.msg_body.includes(url)) {
    //           this.sharableData.type = 2;
    //           this.sharableData.guest_email = contactDetails.email;
    //           this.sharableData.doc_id = url.slice(url.lastIndexOf("/") + 1);
    //           let resp = await this.sendFileModalService
    //             .getSharableLinkForSequence(this.sharableData)
    //             .toPromise();
    //           // .subscribe((resp: any) => {
    //           let res = JSON.parse(resp.response);
    //           actionBlockDetails.msg_body =
    //             actionBlockDetails.msg_body.replaceAll(
    //               url,
    //               url + `?visitcode=${res.token}`
    //             );
    //           if (actionBlockDetails.contact_action_id) {
    //             actionBlockDetails.msg_body =
    //               actionBlockDetails.msg_body.replaceAll(
    //                 url,
    //                 url + `&contact_action_id=[%DOC_CONTACT_ACTION%]`
    //               );
    //           }
    //           // });
    //         }
    //       } else if (url.includes("recordings/view/")) {
    //         if (actionBlockDetails.msg_body.includes(url)) {
    //           this.sharableData.type = 3;
    //           this.sharableData.guest_email = contactDetails.email;
    //           this.sharableData.video_id = url.slice(url.lastIndexOf("/") + 1);
    //           let resp: any = await this.sendFileModalService
    //             .getSharableLinkForSequence(this.sharableData)
    //             .toPromise();
    //           let res = JSON.parse(resp.response);
    //           actionBlockDetails.msg_body =
    //             actionBlockDetails.msg_body.replaceAll(
    //               url,
    //               url + `?visitcode=${res.token}`
    //             );
    //           if (actionBlockDetails.contact_action_id) {
    //             actionBlockDetails.msg_body =
    //               actionBlockDetails.msg_body.replaceAll(
    //                 url,
    //                 url + `&contact_action_id=[%VIDEO_CONTACT_ACTION%]`
    //               );
    //           }
    //         }
    //       } else if (url.includes("pages/")) {
    //         if (actionBlockDetails.msg_body.includes(url)) {
    //           this.sharableData.guest_email = contactDetails.email;
    //           if (url.includes("helloPage")) {
    //             this.sharableData.type = 3;
    //             const urlObject = new URL(url);
    //             const id = urlObject.searchParams.get("id");
    //             this.sharableData.item_id = id;
    //           } else {
    //             this.sharableData.page_id = url.slice(
    //               url.lastIndexOf("/") + 1,
    //               url.indexOf("?")
    //             );
    //             this.sharableData.type = 1;
    //           }
    //           let resp: any = await this.sendFileModalService
    //             .getSharableLinkForSequence(this.sharableData)
    //             .toPromise();
    //           let res = JSON.parse(resp.response);
    //           if (url.includes("helloPage")) {
    //             actionBlockDetails.msg_body =
    //               actionBlockDetails.msg_body.replaceAll(
    //                 "{{VISIT_CODE}}",
    //                 res.token
    //               );
    //           } else {
    //             actionBlockDetails.msg_body =
    //               actionBlockDetails.msg_body.replaceAll(
    //                 url,
    //                 url +
    //                   `&visitcode=${res.token}&name=${contactDetails.firstname}&email=${this.sharableData.guest_email}`
    //               );
    //           }
    //         }
    //       } else if (url.includes("board")) {
    //         if (actionBlockDetails.msg_body.includes(url)) {
    //           let data = {};
    //           this.sharableData.type = 4;
    //           this.sharableData.guest_email = contactDetails.email;
    //           this.sharableData.board_id = url.slice(
    //             url.lastIndexOf("/") + 1,
    //             url.indexOf("?")
    //           );
    //           let resp: any = await this.sendFileModalService
    //             .getSharableLinkForSequence(data)
    //             .toPromise();
    //           // .subscribe((resp: any) => {
    //           let res = JSON.parse(resp.response);
    //           actionBlockDetails.msg_body =
    //             actionBlockDetails.msg_body.replaceAll(
    //               url,
    //               url + `&visitcode=${res.token}`
    //             );
    //           // });
    //         }
    //       }
    //     }
    //   }
    // }
    return actionBlockDetails.msg_body;
  }

  const createAutomatedSequence = async () => {
    console.log('Create a sequence', senderAppAccounts)
    const currentDate = moment().format('DD MMM hh:mm A');
    const formData = new FormData();
    formData.append('name', `AI4Rep-Sequence - ${currentDate}`);
    formData.append('description', '1');
    formData.append('list_type', 'action_block');
    formData.append('email_engine', '2');
    formData.append('list_flags', JSON.stringify({
      dropsPerDay: 25,
      weekDayControl: {
        Monday: true,
        Tuesday: true,
        Wednesday: true,
        Thursday: true,
        Friday: true,
        Saturday: false,
        Sunday: false
      },
      advLinkTracking: false,
      machine_calling_enabled: '0'
    }));
    const appAccountIds = senderAppAccounts.map(item => item.app_account_id).join(',');
    formData.append('sender_app_account_id', appAccountIds);
    const seqResp = await createNewSequence(formData);
    return seqResp
  }

  const AddStepToExistingSequence = async (formData) => {
    console.log('Add step to existing sequence')
    const resp = await addStepToParticularSequence(formData)
    return resp;
  }

  const getEmailStepFormData = (list_id, serial_number, stepData) => {
    const formData = new FormData();
    formData.append('action_type', 'email');
    formData.append('user_id', `${user.userId}`);
    formData.append('list_id', `${list_id}`);
    formData.append('parent_thread_id', null);
    formData.append('actionblock_id', '');
    formData.append('msg_subject', `${stepData.subject}`);
    formData.append('msg_body', `${stepData.msg_body}`);
    formData.append('msg_doc_url', '');
    formData.append('time_offset', `${stepData.time_offset}`);
    formData.append('serial_number', serial_number);
    formData.append('parent_thread_variant_id', '');
    formData.append('msg_format_type', '');
    formData.append('cc_email_list', '');
    formData.append('genai_flag', stepData.isgenEmail ? '1' : '0');
    formData.append('genai_msg_flag', stepData.isgenEmail ? '1' : '0');
    formData.append('parent_id_variant', '');
    formData.append('variant_id', '');
    formData.append('abtest_flag', '1');
    formData.append('template_type', '');
    return formData;
  }

  const handleSelectedSequence = async (selectedSequence, isFromSequenceExe) => {
    console.log('handleSelectedSequence', selectedSequence)
    setSelectedSequenceList(selectedSequence);
    if (!isFromSequenceExe) {
      let stepNum = selectedSequence.action_blocks_count + 1
      const emailStepDatapayload = [];
      const allStepsResp = []
      for (let index = 0; index < emailStep.length; index++) {
        const step = emailStep[index];
        let emailStepData = getEmailStepFormData(selectedSequence.list_id, stepNum, step)
        const payLoadData = {}
        emailStepData.forEach((value, key) => {
          payLoadData[key] = value;
        });
        emailStepDatapayload.push(payLoadData)
        const stepResp = await AddStepToExistingSequence(emailStepData);
        allStepsResp.push(stepResp)
        stepNum = stepNum + 1
      }
      console.log('allStepsResp---->', allStepsResp)
      const listViewDtls = {
        message: `Email step successfully added to ${selectedSequence.list_name}`,
        list_id: selectedSequence.list_id
      }
      const aiMessage = {
        id: uuidv4(),
        type: 'ai',
        message: { newlyCreatedSequence: listViewDtls },
        time: new Date().toISOString(),
        bot_message_id: generateMessageIds().botMessageId
      };
      if (aiMessage) {
        await sendMessageToChat(activeSessionId, 'existing sequence', aiMessage.message, user.userId, sessionType);
        setMessages(prev => [...prev, aiMessage]);
        const dropSeqMessage = {
          id: uuidv4(),
          type: 'ai',
          message: 'Would you like to Drop/Execute this sequence?  (Yes/No)',
          time: new Date().toISOString(),
          bot_message_id: generateMessageIds().botMessageId
        };
        setDropSequenceMode('yesno');
        setMessages(prev => [...prev, dropSeqMessage]);
      }
    } else if (isFromSequenceExe === "engageSequenceForLatestContactList") {
      console.log('Engage sequence for latest contact list-------->', selectedContactList)
      const selectListMsg = {
        id: uuidv4(),
        type: 'ai',
        message: { selectDropTime: 'Droptime' },
        time: new Date().toISOString(),
        bot_message_id: generateMessageIds().botMessageId
      };
      setMessages(prev => [...prev, selectListMsg]);
    } else if (isFromSequenceExe === "handleSequenceExecution") {
      console.log("Execute the sequence---->", selectedDropTime)
      const resp = await getOnepgrContactLists();
      if (resp && resp.success == '0') {
        console.log('conatct list---->', resp.response.lists_listing);
        const selectListMsg = {
          id: uuidv4(),
          type: 'ai',
          message: { selectContactList: resp.response.lists_listing },
          time: new Date().toISOString(),
          bot_message_id: generateMessageIds().botMessageId
        };
        setDropSequenceMode(null);
        setMessages(prev => [...prev, selectListMsg]);
      }
    }
  }

  async function handleSequenceExecution(intent, promptInput) {
    console.log("handleSequenceExecution---->", 'handleSequenceExecution');
    // Get Sequence List First 
    const sequenceList = await getAutomatedSequenceList();
    console.log('sequenceList-->', sequenceList);
    if (sequenceList.success == '0') {
      setAutomatedSequenceList(sequenceList)
      const sequenceListMessage = {
        id: uuidv4(),
        type: 'ai',
        message: { sequenceList: sequenceList, isFromSequenceExe: 'handleSequenceExecution' },
        time: new Date().toISOString(),
        bot_message_id: generateMessageIds().botMessageId
      };
      setMessages(prev => [...prev, sequenceListMessage]);
    }
  }

  function normalizeChannelField(channel) {
    if (Array.isArray(channel)) {
      return channel;
    } else if (typeof channel === 'string') {
      return channel.split(',').map(item => item.trim());
    }
    return [];
  }

  async function handleCreateSequenceAgent(intent, promptInput) {
    console.log("intent---->", intent);
    console.log("promptInput---->", promptInput);
    const channels = normalizeChannelField(intent.editedInfo.channel);
    let channelPrompts = channels.map((channel) => {
      if (channel === "email") {
        return {
          prompt: `write an email that ${intent.extractedInfo.title} will find relevant to ${intent.extractedInfo.jobSignal}`,
          type: "email",
        };
      } else if (channel === "LinkedIn") {
        return {
          prompt: `prepare a LinkedIn outreach for ${intent.extractedInfo.title} related to ${intent.extractedInfo.jobSignal}`,
          type: "linkedin",
        };
      } else if (channel === "call script") {
        return {
          prompt: `develop a call script to discuss ${intent.extractedInfo.jobSignal} with ${intent.extractedInfo.title}`,
          type: "call_script",
        };
      } else if (channel === "video message") {
        return {
          prompt: `create a video message introducing ${intent.extractedInfo.jobSignal} to ${intent.extractedInfo.title}`,
          type: "video_message",
        };
      } else if (channel === "SMS" || channel === "sms") {
        return {
          prompt: `compose an SMS highlighting ${intent.extractedInfo.jobSignal} for ${intent.extractedInfo.title}`,
          type: "sms",
        };
      } else if (channel === "genAI email") {
        return {
          prompt: `generate an AI-powered email prompt tailored to ${intent.extractedInfo.jobSignal} for ${intent.extractedInfo.title}`,
          type: "genai_email",
        };
      } else {
        return {
          prompt: `use ${channel} to engage ${intent.extractedInfo.title} with ${intent.extractedInfo.jobSignal}`,
          type: channel,
        };
      }
    });

    console.log("channelPrompts--->", channelPrompts);
    for (let i = 0; i < channelPrompts.length; i++) {
      let channelType = channelPrompts[i].type;
      let prompt = channelPrompts[i].prompt;
      if (channelType === 'email' || channelType === 'genai_email') {
        let parsedEmail;
        if (channelType === 'email') {
          parsedEmail = await processEmailRequest('', '', '', activeSessionId, prompt);
        }
        if (channelType === 'genai_email') {
          parsedEmail = await createGenAIPrompt('', '', activeSessionId, prompt);
        }
        if (parsedEmail) {
          console.log("parsedEmail---->", parsedEmail.email_content);
          let subject = parsedEmail.email_content ? parsedEmail.email_content.subject : "Subject not found";
          let body = parsedEmail.email_content ? parsedEmail.email_content.body : parsedEmail;
          const emailStepData = {
            subject: subject,
            msg_body: body,
            time_offset: '0',
            isgenEmail: channelType === 'email' ? false : true
          }
          setEmailStep(prev => [...prev, emailStepData])
          const emailMessage = {
            id: uuidv4(),
            type: 'ai',
            message: { emailData: { subject: subject, body: body } }
          };
          setMessages(prev => [...prev, emailMessage]);
        }
      } else {
        // const babuResp = await getBabuLangchainResponse(prompt, activeSessionId);
        // console.log("babuResp---->", babuResp);
        //   const babuResp = await getBabuLangchainResponse(prompt, activeSessionId);
        //   const emailMessage = {
        //     id: uuidv4(),
        //     type: 'ai',
        //     message: babuResp.message.response
        //   };
        //   setMessages(prev => [...prev, emailMessage]);
        console.warn("......Need to Implement further steps......")
      }
    }
    setSequenceMode('type');
    let aiMessage = {
      id: uuidv4(),
      type: 'ai',
      message: "How would you like to add this steps to sequence? Options are: new sequence or existing sequence",
      time: new Date().toISOString(),
      bot_message_id: generateMessageIds().botMessageId
    };
    setMessages(prev => [...prev, aiMessage]);
  }

  const toggleSequenceReviewModal = (val) => {
    setToggleSequenceReview(val);
  }

  const executeSequence = async () => {
    try {
      toggleSequenceReviewModal(false);
      setIsTyping(true);
      const {
        sequenceData,
        dropId,
        allContactActions,
        selectedDropTime,
        contactListData,
      } = scheduledCotactionsRef.current;
      await createAndScheduleEmails(
        sequenceData,
        dropId,
        allContactActions,
        selectedDropTime,
        contactListData
      );
    } catch (error) {
      setIsTyping(false);
      const errorMessage = {
        id: uuidv4(),
        type: "ai",
        message: "Sequence Execution failed",
        time: new Date().toISOString(),
      };
      setMessages((prev) => [...prev, errorMessage]);
    } finally {
      setIsTyping(false);
    }
  }


  async function handleIpEnrichment(intent, input, IpAddress) {
    // console.log("Input received in handleIpEnrichment:", IpAddress);
    const ipAddress = intent.extractedInfo.ipAddress
    try {
      // Extract the IP address from the input
      // const ipAddressMatch = input.match(/\b\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\b/);
      // if (!ipAddressMatch) {
      //   console.error("No valid IP address found in input.");
      //   setMessages((prev) => [
      //     ...prev,
      //     {
      //       id: uuidv4(),
      //       type: 'ai',
      //       message: 'Failed to enrich data. No valid IP address found in the input.',
      //       time: new Date().toISOString(),
      //     },
      //   ]);
      //   return;
      // }

      // const ipAddress = ipAddressMatch[0]; // Extracted IP address
      // console.log("Extracted IP address:", ipAddress);

      console.log("Sending IP enrichment request to API...");
      // Call the IP enrichment API using POST with a JSON body
      const response = await axios.post(
        'https://videoresponse.onepgr.com:3001/ip/enrich',
        { ip: ipAddress },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.data) {
        console.log("Enrichment data received:", response.data);
        const { userMessageId, botMessageId } = generateMessageIds();
        const ipEnrich = {
          id: uuidv4(),
          type: 'ai',
          message: { ipEnrich: response.data },
          data: response.data,

          time: new Date().toISOString(),
          bot_message_id: botMessageId
        }
        console.log(ipEnrich);
        setMessages((prev) => [
          ...prev, ipEnrich

        ]);
        await sendMessageToChat(sessionId, input, { ipEnrich: response.data }, user.userId, sessionType, '', '', userMessageId, botMessageId);
      } else {
        throw new Error("Invalid response from enrichment API.");
      }
    } catch (error) {
      console.error("Error in handleIpEnrichment:", error);
      setMessages((prev) => [
        ...prev,
        {
          id: uuidv4(),
          type: 'ai',
          message: 'Failed to enrich data. Please try again later.',
          time: new Date().toISOString(),
          bot_message_id: generateMessageIds().botMessageId
        },
      ]);
    }
  }

  const handleLinkedInMessages = async (data, sessionId, input) => {
    console.log('LinkedIn Messages data:', data);

    try {
      // Get LinkedIn cookie first
      const linkedinCookie = await getLinkedInCookie(user.userId || user.id);

      // Make the API call to scrape LinkedIn messages
      const response = await axios.post(
        'https://videoresponse.onepgr.com:3001/scrapeinbox',
        { sessionCookie: linkedinCookie },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      console.log("LinkedIn inbox data response:", response.data);
      let newMessages = [];

      if (!response.data || response.data.error) {
        const { userMessageId, botMessageId } = generateMessageIds();
        const noDataMessage = {
          id: uuidv4(),
          type: 'ai',
          message: 'No LinkedIn messages could be retrieved.',
          time: new Date().toISOString(),
          bot_message_id: botMessageId
        };
        newMessages.push(noDataMessage);
        await sendMessageToChat(sessionId, input, noDataMessage.message, user.userId, sessionType, '', '', userMessageId, botMessageId);
        } else {
          // Create message with LinkedIn inbox data
          const { userMessageId, botMessageId } = generateMessageIds();
        const inboxMessage = {
          id: uuidv4(),
          type: 'ai',
          message: { linkedInInboxData: response.data },
          time: new Date().toISOString(),
          bot_message_id: botMessageId
        };

        newMessages.push(inboxMessage);

        // Send message to chat
        await sendMessageToChat(
          sessionId,
          input,
          JSON.stringify(inboxMessage.message),
          user.userId,
          sessionType,
          '',
          '',
          userMessageId,
          botMessageId
        );
      }

      // Update messages state
      setMessages(prev => [...prev, ...newMessages]);

    } catch (error) {
      console.error('Error handling LinkedIn messages:', error);
      const { userMessageId, botMessageId } = generateMessageIds();
      const errorMessage = {
        id: uuidv4(),
        type: 'ai',
        message: `Error retrieving LinkedIn messages: ${error.message}`,
        time: new Date().toISOString(),
        bot_message_id: botMessageId
      };
      await sendMessageToChat(sessionId, input, errorMessage.message, user.userId, sessionType, '', '', userMessageId, botMessageId);
      setMessages(prev => [...prev, errorMessage]);
    }
  };

  const handleLinkedInEventAttendees = async (data, sessionId, input) => {
    console.log('LinkedIn Event data:', data);
    
    try {
      // Make the API call using the provided eventUrl and sessionCookie
      const response = await axios.post(
        'https://videoresponse.onepgr.com:3001/EventGuestsScrap',
        {
          eventUrl: data.eventUrl,
          sessionCookie: data.sessionCookie
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
  
      let newMessages = [];
  
      if (!response.data || response.data.error) {
        const { userMessageId, botMessageId } = generateMessageIds();
        const noDataMessage = {
          id: uuidv4(),
          type: 'ai',
          message: 'No event attendees could be retrieved. Make sure you are registered for the event.',
          time: new Date().toISOString(),
          bot_message_id: botMessageId
        };
        newMessages.push(noDataMessage);
        await sendMessageToChat(sessionId, input, noDataMessage.message, user.userId, sessionType, '', '', userMessageId, botMessageId);
      } else {
        const { userMessageId, botMessageId } = generateMessageIds();
        // Create message with event attendees data
        const attendeesMessage = {
          id: uuidv4(),
          type: 'ai',
          message: { eventAttendeesData: response.data },
          time: new Date().toISOString(),
          bot_message_id: botMessageId
        };
        
        newMessages.push(attendeesMessage);
  
        await sendMessageToChat(
          sessionId,
          input,
          JSON.stringify(attendeesMessage.message),
          user.userId,
          sessionType,
          '',
          '',
          userMessageId,
          botMessageId
        );
      }
  
      setMessages(prev => [...prev, ...newMessages]);
  
    } catch (error) {
      console.error('Error handling LinkedIn event attendees:', error);
      const { userMessageId, botMessageId } = generateMessageIds();
      const errorMessage = {
        id: uuidv4(),
        type: 'ai',
        message: `Error retrieving event attendees: ${error.message}`,
        time: new Date().toISOString(),
        bot_message_id: botMessageId
      };
      await sendMessageToChat(sessionId, input, errorMessage.message, user.userId, sessionType, '', '', userMessageId, botMessageId);
      setMessages(prev => [...prev, errorMessage]);
    }
  };


  async function handleVideoCreator(intent, input) {
    console.log("Input received in handleVideoCreator:", input);

    let imageUrl = '';
    let promptText = '';

    if (typeof input === 'object' && input !== null) {
      imageUrl = input.imageUrl;
      promptText = input.promptText;
    } else if (typeof input === 'string') {
      // Use a regex to find the image URL and split the promptText accordingly
      const urlRegex = /(https?:\/\/[^\s]+)/; // Matches any valid URL
      const match = input.match(urlRegex);

      if (match) {
        imageUrl = match[0]; // Extract the URL
        promptText = input.replace(urlRegex, '').replace('create a video', '').trim(); // Remove URL and 'create a video'
      }

      // Log parsed values for debugging
      console.log("Parsed promptText:", promptText);
      console.log("Parsed imageUrl:", imageUrl);

      // Check if both fields are populated
      if (!promptText || !imageUrl) {
        const { userMessageId, botMessageId } = generateMessageIds();
        console.error("Invalid raw string input. Missing promptText or imageUrl.");
        setMessages((prev) => [
          ...prev,
          {
            id: uuidv4(),
            type: 'ai',
            message: 'Failed to generate video. Invalid input format.',
            time: new Date().toISOString(),
            bot_message_id: botMessageId
          },
        ]);
        return;
      }
    }


    if (!imageUrl || !promptText) {
      console.error("Missing imageUrl or promptText:", { imageUrl, promptText });
      setMessages((prev) => [
        ...prev,
        {
          id: uuidv4(),
          type: 'ai',
          message: 'Failed to generate video. Missing required fields.',
          time: new Date().toISOString(),
        },
      ]);
      return;
    }

    try {
      const response = await axios.post(
        'https://videoresponse.onepgr.com:3001/generate-video',
        { imageUrl, promptText },
        { withCredentials: true }
      );
      if (response.data && response.data.videoUrl) {
        console.log("Video URL received:", response.data.videoUrl);
        const { userMessageId, botMessageId } = generateMessageIds();
        const videoResponseMessage = {
          id: uuidv4(),
          type: 'ai',
          message: { creaetedVideoURl: response.data.videoUrl }, // Message contains the createdVideoURL
          videoUrl: response.data.videoUrl, // Direct access to the video URL
          time: new Date().toISOString(),
          bot_message_id: botMessageId
        };

        setMessages((prev) => [
          ...prev, videoResponseMessage

        ]);
        await sendMessageToChat(sessionId, input, { creaetedVideoURl: response.data.videoUrl }, videoResponseMessage, user.userId, sessionType, '', '', userMessageId, botMessageId);
      } else {
        throw new Error("Invalid response from API");
      }
    } catch (error) {
      console.error("Error in handleVideoCreator:", error);
      const { userMessageId, botMessageId } = generateMessageIds();
      setMessages((prev) => [
        ...prev,
        {
          id: uuidv4(),
          type: 'ai',
          message: 'Failed to generate video. Please try again later.',
          time: new Date().toISOString(),
          bot_message_id: botMessageId
        },
      ]);
    }
  }

  const handleScrapedJobData = async ({ keywords, location }, sessionId, input) => {
    try {
        // API call to fetch LinkedIn job data
        const response = await fetch('https://videoresponse.onepgr.com:3001/linkdinjobsscraper', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ keywords, location })
        });

        if (!response.ok) {
            throw new Error(`API call failed with status: ${response.status}`);
        }

        const result = await response.json();
        console.log('LinkedIn Jobs Scraper Result:', result);

        if (!result.data || result.data.length === 0) {
            // Handle case where no jobs are found
            const { userMessageId, botMessageId } = generateMessageIds();
            const noJobsMessage = {
                id: uuidv4(),
                type: 'ai',
                message: 'No job listings were found. Please refine your search criteria.',
                time: new Date().toISOString(),
                bot_message_id: botMessageId
            };
            await sendMessageToChat(sessionId, input, noJobsMessage.message, user.userId, sessionType, '', '', userMessageId, botMessageId);
            setMessages(prev => [...prev, noJobsMessage]);
            return;
        }

        // Create message with job listings data
        const { userMessageId, botMessageId } = generateMessageIds();
        const jobsMessage = {
            id: uuidv4(),
            type: 'ai',
            message: { jobListings: result.data },
            time: new Date().toISOString(),
            bot_message_id: botMessageId
        };

        await sendMessageToChat(
            sessionId,
            input,
            JSON.stringify(jobsMessage.message),
            user.userId,
            sessionType,
            '',
            '',
            userMessageId,
            botMessageId
        );
        setMessages(prev => [...prev, jobsMessage]);
    } catch (error) {
        // Handle error and notify user
        console.error('Error handling LinkedIn job data:', error);
        const { userMessageId, botMessageId } = generateMessageIds();
        const errorMessage = {
            id: uuidv4(),
            type: 'ai',
            message: `Error retrieving job data: ${error.message}`,
            time: new Date().toISOString(),
            bot_message_id: botMessageId
        };
        await sendMessageToChat(sessionId, input, errorMessage.message, user.userId, sessionType, '', '', userMessageId, botMessageId);
        setMessages(prev => [...prev, errorMessage]);
    }
};

const handleJobDetails = async ({ jobUrl }, sessionId, input) => {
  try {
      // Check if jobUrl is valid
      if (!jobUrl) {
          throw new Error('Job URL is missing or invalid.');
      }

      // API call to fetch LinkedIn job details
      const response = await fetch('https://videoresponse.onepgr.com:3001/getdeepjobdetails', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify({ jobUrl })
      });

      if (!response.ok) {
          throw new Error(`API call failed with status: ${response.status}`);
      }

      const result = await response.json();
      console.log('LinkedIn Job Details Result:', result);

      if (!result.data) {
          // Handle case where no job details are found
          const { userMessageId, botMessageId } = generateMessageIds();
          const noDetailsMessage = {
              id: uuidv4(),
              type: 'ai',
              message: 'Sorry, no detailed job information was found for the provided URL.',
              time: new Date().toISOString(),
              bot_message_id: botMessageId
          };
          await sendMessageToChat(sessionId, input, noDetailsMessage.message, user.userId, sessionType, '', '', userMessageId, botMessageId);
          setMessages(prev => [...prev, noDetailsMessage]);
          return;
      }
       
      const { userMessageId, botMessageId } = generateMessageIds();
      // Create message with job details data
      const jobDetailsMessage = {
          id: uuidv4(),
          type: 'ai',
          message: { jobDetails: result.data },
          time: new Date().toISOString(),
          bot_message_id: botMessageId
      };

      await sendMessageToChat(
          sessionId,
          input,
          JSON.stringify(jobDetailsMessage.message),
          user.userId,
          sessionType,
          '',
          '',
          userMessageId,
          botMessageId
      );
      setMessages(prev => [...prev, jobDetailsMessage]);
  } catch (error) {
      // Internal error handling and sending error message
      console.error('Error handling LinkedIn job details:', error);
      const { userMessageId, botMessageId } = generateMessageIds();
      const errorMessage = {
          id: uuidv4(),
          type: 'ai',
          message: `Error retrieving job details: ${error.message}`,
          time: new Date().toISOString(),
          bot_message_id: botMessageId
      };

      await sendMessageToChat(sessionId, input, errorMessage.message, user.userId, sessionType, '', '', userMessageId, botMessageId);
      setMessages(prev => [...prev, errorMessage]);
  }
};

const handleFundingAcquisitionData = async (data, sessionId, userInput) => {
  try {
    // Format the data with null checks and fallbacks
    const formattedData = {
      companyInfo: {
        name: data.company_name || 'N/A',
        url: data.company_url || '#',
        location: [
          data.company_city,
          data.company_region?.toUpperCase(),
          data.company_country_code?.toUpperCase()
        ].filter(Boolean).join(', ') || 'Location not available',
        address: [
          data.company_street,
          data.company_zip_code
        ].filter(Boolean).join(', ') || 'Address not available'
      },
      ratings: {
        overall: data.ratings_overall || 0,
        totalReviews: data.total_reviews_count || 0,
        metrics: {
          'Business Outlook': data.ratings_business_outlook ? `${(data.ratings_business_outlook * 100).toFixed(1)}%` : 'N/A',
          'Career Opportunities': data.ratings_career_opportunities?.toFixed(1) || 'N/A',
          'CEO Approval': data.ratings_ceo_approval ? 
            `${(data.ratings_ceo_approval * 100).toFixed(1)}% (${data.ratings_ceo_approval_count || 0} votes)` : 'N/A',
          'Compensation & Benefits': data.ratings_compensation_benefits?.toFixed(1) || 'N/A',
          'Diversity & Inclusion': data.ratings_diversity_inclusion?.toFixed(1) || 'N/A',
          'Senior Management': data.ratings_senior_management?.toFixed(1) || 'N/A',
          'Work/Life Balance': data.ratings_work_life_balance?.toFixed(1) || 'N/A',
          'Recommend to Friend': data.ratings_recommend_to_friend ? 
            `${(data.ratings_recommend_to_friend * 100).toFixed(1)}%` : 'N/A'
        }
      }
    };

    const { userMessageId, botMessageId } = generateMessageIds();
    const message = {
      id: uuidv4(),
      type: 'ai',
      message: {
        fundingAcquisitionData: formattedData
      },
      time: new Date().toISOString(),
      bot_message_id: botMessageId
    };
    setMessages(prev => [...prev, message]);

    await sendMessageToChat(
      sessionId,
      userInput,
      JSON.stringify(message.message),
      user.userId,
      sessionType,
      '',
      '',
      userMessageId,
      botMessageId
    );

  } catch (error) {
    console.error('Error handling funding acquisition data:', error);
    const { userMessageId, botMessageId } = generateMessageIds();
    const errorMessage = {
      id: uuidv4(),
      type: 'ai',
      message: `Error processing company data: ${error.message}`,
      time: new Date().toISOString(),
      bot_message_id: botMessageId
    };
    setMessages(prev => [...prev, errorMessage]);
    
    await sendMessageToChat(
      sessionId,
      userInput,
      errorMessage.message,
      user.userId,
      sessionType,
      '',
      '',
      userMessageId,
      botMessageId
    );
  }
};

const handleFundingAnnouncement = async (data, sessionId, userInput) => {
  try {
    // Check if data is empty or invalid
    if (!data?.FundingannounmenetData?.output_events) {
      console.log('No funding announcement data available');
      const { userMessageId, botMessageId } = generateMessageIds();
      const message = {
        id: uuidv4(),
        type: 'ai',
        message: {
          fundingAnnouncements: {
            investments: [],
            products: [],
            summary: {
              totalInvestment: 0,
              totalInvestments: 0,
              totalProducts: 0,
              dateRange: { start: null, end: null }
            },
            message: 'No funding announcements found for this company.'
          }
        },
        time: new Date().toISOString(),
        bot_message_id: botMessageId
      };
      setMessages(prev => [...prev, message]);

      await sendMessageToChat(
        sessionId,
        userInput,
        JSON.stringify(message.message),
        user.userId,
        sessionType,
        '',
        '',
        userMessageId,
        botMessageId
      );
      return;
    }
    
    const events = data.FundingannounmenetData.output_events;
    
    // Group events by type
    const investments = events.filter(event => event.event_name === 'new_investment') || [];
    const products = events.filter(event => event.event_name === 'new_product') || [];
    
    // Calculate total investment amount
    const totalInvestment = investments.reduce((sum, event) => 
      sum + (event.data?.investment_amount || 0), 0);

    const formattedData = {
      investments: investments.map(event => ({
        amount: event.data?.investment_amount || 0,
        date: event.data?.investment_date ? new Date(event.data.investment_date).toLocaleDateString() : 'N/A',
        target: event.data?.investment_target || 'Unknown',
        type: event.data?.investment_type || 'Unknown',
        link: event.data?.link || '#'
      })),
      products: products.map(event => ({
        name: event.data?.product_name || 'Unknown',
        date: event.event_time ? new Date(event.event_time).toLocaleDateString() : 'N/A',
        link: event.data?.link || '#'
      })),
      summary: {
        totalInvestment,
        totalInvestments: investments.length,
        totalProducts: products.length,
        dateRange: {
          start: events.length > 0 ? new Date(Math.min(...events.map(e => new Date(e.event_time)))).toLocaleDateString() : null,
          end: events.length > 0 ? new Date(Math.max(...events.map(e => new Date(e.event_time)))).toLocaleDateString() : null
        }
      }
    };

    const { userMessageId, botMessageId } = generateMessageIds();
    const message = {
      id: uuidv4(),
      type: 'ai',
      message: {
        fundingAnnouncements: formattedData
      },
      time: new Date().toISOString(),
      bot_message_id: botMessageId
    };
    setMessages(prev => [...prev, message]);

    await sendMessageToChat(
      sessionId,
      userInput,
      JSON.stringify(message.message),
      user.userId,
      sessionType,
      '',
      '',
      userMessageId,
      botMessageId
    );

  } catch (error) {
    console.error('Error handling funding announcement data:', error);
    const { userMessageId, botMessageId } = generateMessageIds();
    const errorMessage = {
      id: uuidv4(),
      type: 'ai',
      message: {
        fundingAnnouncements: {
          investments: [],
          products: [],
          summary: {
            totalInvestment: 0,
            totalInvestments: 0,
            totalProducts: 0,
            dateRange: { start: null, end: null }
          },
          error: 'Error processing funding announcements data.'
        }
      },
      time: new Date().toISOString(),
      bot_message_id: botMessageId
    };
    setMessages(prev => [...prev, errorMessage]);
    
    await sendMessageToChat(
      sessionId,
      userInput,
      JSON.stringify(errorMessage.message),
      user.userId,
      sessionType,
      '',
      '',
      userMessageId,
      botMessageId
    );
  }
};

const handlePersonJobChanges = async (data, sessionId, userInput) => {
  console.log('Person Job Changes Data:', data);
  try {
    // Check if data is empty or invalid
    if (!data?.changes) {
      console.log('No person job changes data available');
      const { userMessageId, botMessageId } = generateMessageIds();
      const message = {
        id: uuidv4(),
        type: 'ai',
        message: {
          personJobChanges: {
            changes: [],
            summary: {
              totalChanges: 0,
              companyChanges: 0,
              roleChanges: 0,
              anniversaries: 0
            },
            message: 'No job changes found for this person.'
          }
        },
        time: new Date().toISOString(),
        bot_message_id: botMessageId
      };
      setMessages(prev => [...prev, message]);

      await sendMessageToChat(
        sessionId,
        userInput,
        JSON.stringify(message.message),
        user.userId,
        sessionType,
        '',
        '',
        userMessageId,
        botMessageId
      );
      return;
    }
    
    const changes = data.changes || [];
    const summary = data.summary || {};
    
    const formattedData = {
      changes: changes.map(change => ({
        eventName: change.event_name.replace(/_/g, ' ').toUpperCase(),
        date: change.event_time ? new Date(change.event_time).toLocaleDateString() : 'N/A',
        previousJob: change.previous_job_title || 'Unknown',
        previousCompany: change.previous_company_name || 'Unknown',
        currentJob: change.current_job_title || 'Unknown',
        currentCompany: change.current_company_name || 'Unknown'
      })),
      summary: {
        totalChanges: summary.total_changes || 0,
        companyChanges: summary.company_changes || 0,
        roleChanges: summary.role_changes || 0,
        anniversaries: summary.anniversaries || 0
      }
    };

    const { userMessageId, botMessageId } = generateMessageIds();
    const message = {
      id: uuidv4(),
      type: 'ai',
      message: {
        personJobChanges: formattedData
      },
      time: new Date().toISOString(),
      bot_message_id: botMessageId
    };
    setMessages(prev => [...prev, message]);

    await sendMessageToChat(
      sessionId,
      userInput,
      JSON.stringify(message.message),
      user.userId,
      sessionType,
      '',
      '',
      userMessageId,
      botMessageId
    );

  } catch (error) {
    console.error('Error handling person job changes data:', error);
    const { userMessageId, botMessageId } = generateMessageIds();
    const errorMessage = {
      id: uuidv4(),
      type: 'ai',
      message: {
        personJobChanges: {
          changes: [],
          summary: {
            totalChanges: 0,
            companyChanges: 0,
            roleChanges: 0,
            anniversaries: 0
          },
          error: 'Error processing person job changes data.'
        }
      },
      time: new Date().toISOString(),
      bot_message_id: botMessageId
    };
    setMessages(prev => [...prev, errorMessage]);
    
    await sendMessageToChat(
      sessionId,
      userInput,
      JSON.stringify(errorMessage.message),
      user.userId,
      sessionType,
      '',
      '',
      userMessageId,
      botMessageId
    );
  }
};

  return (
    <div className="chat-container">
      <NavBar toggleSidebar={toggleSidebar} 
      onLogout={handleLogout} 
      isStarred={isStarred} 
      toggleStar={toggleStar}  
      handleStarChat={handleStarChat}/>
      <div
        ref={sidebarTriggerRef}
        className="sidebar-trigger"
        style={{
          position: 'fixed',
          left: 0,
          top: 0,
          width: '10px',
          height: '100%',
          zIndex: 100
        }}
      />
      <div
        ref={sidebarRef}
        className={`sidebar-wrapper ${isSidebarOpen ? 'open' : ''}`}
        onMouseLeave={handleSidebarMouseLeave}
      > <Sidebar
          onLogout={onLogout}
          onNewChat={handleNewChat}
          userId={user.userId}
          recentChats={recentChats}
          activeSessionId={activeSessionId}
          onChatSelect={(sessionId) => navigate(`/chat/${sessionId}`)}
          toggleSidebar={toggleSidebar}
          favouriteChats={favouriteChats}
        />
      </div>
      <div className={`main-content ${isSidebarOpen ? 'shifted' : ''}`}>
        <div className="message-area" ref={messageAreaRef}>
          <MessageList
            messages={messages}
            onEditMessage={handleEditMessage}
            editingMessageId={editingMessageId}
            onCancelEdit={handleCancelEdit}
            onSaveEdit={handleSaveEdit}
            reviewData={reviewData}
            onReviewAction={handleReviewAction}
            isTyping={isTyping}
            showWelcomeMessage={showWelcomeMessage}
            onToggleWelcomeMessage={handleToggleWelcomeMessage}
            onExamplePromptClick={handleExamplePromptClick}
            isEnriched={isEnriched}
            onSaveContacts={handleSaveContacts}
            handleSelectedSequence={handleSelectedSequence}
            handleSelectedContactList={handleSelectedContactList}
            handleSelectDropTime={handleSelectDropTime}
            handleSaveToOnepgrContactlist={handleSaveToOnepgrContactlist}
            onTriggerEnrichment={handleTriggerEnrichment}
            onViewProfile={handleViewProfile}
            isOpenedByFindPeopleCard={isOpenedByFindPeopleCard}
            isOpenedByLikesAndCommentsCard={isOpenedByLikesAndCommentsCard}
            isOpenedByEmployeesSearchCard={isOpenedByEmployeesSearchCard}
            isOpenedByLinkedInProfileCard={isOpenedByLinkedInProfileCard}
            isOpenedByCompanyProfileCard={isOpenedByCompanyProfileCard}
            onSendMessage={handleUserInput}
          />
          <div ref={messagesEndRef} />
        </div>

        <MessageInput onSendMessage={handleUserInput} disabled={isTyping} enrichmentMode={enrichmentMode}
          sequenceMode={sequenceMode} dropSequenceMode={dropSequenceMode} engageSequenceMode={engageSequenceMode}
        />
        {showScrollButton && (
          <button onClick={scrollToBottom} className="scroll-button">
            <ChevronDown size={20} />
          </button>
        )}
      </div>
      {user && (
        <div className={`user-info-avatar ${isSidebarOpen ? 'hidden' : ''}`} >
          <div className="user-fixed-avatar" onClick={toggleSidebar}>
            {getAvatarContent()}
          </div>
        </div>
      )}
      {toggleSequenceReview && (
        <ReviewSequenceModal executeSequence={executeSequence}
          toggleSequenceReviewModal={toggleSequenceReviewModal}
          contactActionsData={scheduledCotactionsRef.current}
        />
      )}
    </div>
  );
};

export default ChatInterface;